/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} checkoutMinimumOrderClickOnGotItInErrorModalInCheckoutParams
* @property {string} appName - app_name
* @property {GUID} cartId - null
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - only in EP
* @property {string} currency - the currency that was shown in the message
* @property {number} diffLong - The diff between the relevant order value and the minimum order threshold  multiplied by 100,000
* @property {GUID} ecomId - ecom_id
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} minimumValueLong - the minimum order threshold multiplied by 100,000
* @property {string} stage - the stage in the checkout the visitor was at when the modal was opened
**/
/**
 * Name: Checkout -> Minimum order - click on ‘got it’ in error modal in checkout. Evid: 655.
 * Event description: Minimum order - click on ‘got it’ in error modal in checkout.

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid.
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: only in EP
 *
 * currency - Type: string. Desc: the currency that was shown in the message
 *
 * diffLong - Type: numeric. Desc: The diff between the relevant order value and the minimum order threshold  multiplied by 100,000
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * minimumValueLong - Type: numeric. Desc: the minimum order threshold multiplied by 100,000
 *
 * stage - Type: string. Desc: the stage in the checkout the visitor was at when the modal was opened
 * @param {checkoutMinimumOrderClickOnGotItInErrorModalInCheckoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutMinimumOrderClickOnGotItInErrorModalInCheckout = function (params) {
    return { evid: 655, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} cartClickOnCartIconToOpenMiniCartParams
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {number} itemsCount - Numbers of items in cart
* @property {GUID} ecomId - ecom_id
* @property {boolean} isNavigateCart - hard coded false (for Anodot)
* @property {string} viewMode - editor / site / preview
**/
/**
 * Name: Cart -> Click on cart icon to open mini cart. Evid: 49.
 * Event description: click on cart icon to open the mini cart.

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * itemsCount - Type: numeric. Desc: Numbers of items in cart
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isNavigateCart - Type: bool. Desc: hard coded false (for Anodot)
 *
 * viewMode - Type: string. Desc: editor / site / preview
 * @param {cartClickOnCartIconToOpenMiniCartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartClickOnCartIconToOpenMiniCart = function (params) {
    return { evid: 49, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} thankYouPageLoadSfParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - null
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {string} checkoutId - Order.checkoutId
* @property {GUID} ecomId - ecom_id
* @property {string} itemType - List of distinct Order.lineItems.itemType
* @property {number} numOfLineItems - Count distinct Order.lineItems.id
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {string} orderId - orderId
* @property {string} origin - the state of the panel when the user clicked on the button
* @property {string} paymentMethodType - List of distinct Order.lineItems.paymentOption
* @property {string} paymentProvider - null
* @property {string} payment_status - payment_status
* @property {string} viewMode - DESKTOP etc.
**/
/**
 * Name: Thank you page-> load SF. Evid: 174.
 * Event description: this event indicates when the "thank you page" was presented to the user:.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string.
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: string. Desc: Order.checkoutId
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * itemType - Type: string. Desc: List of distinct Order.lineItems.itemType
 *
 * numOfLineItems - Type: numeric. Desc: Count distinct Order.lineItems.id
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * orderId - Type: string. Desc: orderId
 *
 * origin - Type: string. Desc: the state of the panel when the user clicked on the button
 *
 * paymentMethodType - Type: string. Desc: List of distinct Order.lineItems.paymentOption
 *
 * paymentProvider - Type: string.
 *
 * payment_status - Type: string. Desc: payment_status
 *
 * viewMode - Type: string. Desc: DESKTOP etc.
 * @param {thankYouPageLoadSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thankYouPageLoadSf = function (params) {
    return { evid: 174, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickOnBackInCheckoutProcessParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {boolean} isOwner - true if visitor is the site owner
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {GUID} owner_id - uuid of site owner
* @property {string} previousStage - the closed stage - payment / shippingDetails / deliveryMethod / payment-method / pickupDetails / shipping-method / customerDetails
* @property {string} stage - which stage in the wishlist installation process
**/
/**
 * Name: Checkout -> click on 'back' in checkout process. Evid: 170.
 * Event description: click on 'back' or 'edit' in checkout process. since june 2019 also sent from OneApp.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isOwner - Type: bool. Desc: true if visitor is the site owner
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * owner_id - Type: guid. Desc: uuid of site owner
 *
 * previousStage - Type: string. Desc: the closed stage - payment / shippingDetails / deliveryMethod / payment-method / pickupDetails / shipping-method / customerDetails
 *
 * stage - Type: string. Desc: which stage in the wishlist installation process
 * @param {clickOnBackInCheckoutProcessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnBackInCheckoutProcess = function (params) {
    return { evid: 170, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} updatedCartItemQuantitySfParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in cart
* @property {string} appName - app_name
* @property {GUID} cartId - cart id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} checkoutId - checkout_id
* @property {number} itemsCount - number of items in the cart
* @property {GUID} ecomId - ecom_id
* @property {number} numberOfAdditionalFees - number of all additional fees in the cart
* @property {string} origin - origin
* @property {GUID} owner_id - id of site's owner. since june 2019
* @property {string} productId - product_id
**/
/**
 * Name: Cart -> Updated cart item quantity SF. Evid: 116.
 * Event description: Updated cart item quantity.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in cart
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * itemsCount - Type: numeric. Desc: number of items in the cart
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the cart
 *
 * origin - Type: string. Desc: origin
 *
 * owner_id - Type: guid. Desc: id of site's owner. since june 2019
 *
 * productId - Type: string. Desc: product_id
 * @param {updatedCartItemQuantitySfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var updatedCartItemQuantitySf = function (params) {
    return { evid: 116, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickOnAddToCartParams
* @property {string} appName - app_name
* @property {string} buttonType - buy now / add to cart / subscribe now
* @property {GUID} checkoutId - checkout_id
* @property {number} quantity - added product quntety
* @property {boolean} hasOptions - does the product have options
* @property {boolean} isNavigateCart - true if the button redirect to cart (mobile or without cart icon), false otherwise
* @property {string} navigationClick - mini-cart / cart  / none / checkout
* @property {string} options - a json containing the options selected for the product
* @property {string} origin - origin
* @property {GUID} owner_id - id of site's owner. since june 2019
* @property {string} productId - product_id
* @property {string} productType - digital / physical
* @property {GUID} uuid - uuid
* @property {string} viewMode - editor / site / preview
**/
/**
 * Name: Click on add to cart. Evid: 63.
 * Event description: buyer clicks on add to cart. Also since june 2019 can be sent from OneApp store front (member view) with origin ='OA StoreFront'. Currently not sent from src 130, under disscussions.

 * appName - Type: string. Desc: app_name
 *
 * buttonType - Type: string. Desc: buy now / add to cart / subscribe now
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * quantity - Type: numeric. Desc: added product quntety
 *
 * hasOptions - Type: bool. Desc: does the product have options
 *
 * isNavigateCart - Type: bool. Desc: true if the button redirect to cart (mobile or without cart icon), false otherwise
 *
 * navigationClick - Type: string. Desc: mini-cart / cart  / none / checkout
 *
 * options - Type: string. Desc: a json containing the options selected for the product
 *
 * origin - Type: string. Desc: origin
 *
 * owner_id - Type: guid. Desc: id of site's owner. since june 2019
 *
 * productId - Type: string. Desc: product_id
 *
 * productType - Type: string. Desc: digital / physical
 *
 * uuid - Type: guid. Desc: uuid
 *
 * viewMode - Type: string. Desc: editor / site / preview
 * @param {clickOnAddToCartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnAddToCart = function (params) {
    return { evid: 63, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickOnAddNoteToSellerSfParams
* @property {string} appName - app_name
* @property {GUID} cartId - cart id
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)v
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} origin - OA StoreFront
**/
/**
 * Name: Cart -> Click on add note to seller SF. Evid: 121.
 * Event description: buyer clicks on 'add note to seller' in cart page. since june 2019 also sent from OA StoreFront (with origin).

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)v
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * origin - Type: string. Desc: OA StoreFront
 * @param {clickOnAddNoteToSellerSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnAddNoteToSellerSf = function (params) {
    return { evid: 121, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutPageSpecificStageExpandedParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} additionalRequiredField - only for 'placeOrderFastFlow' stage: required additional field that we didnt get info fron PayPal) for "Place Order" button to be clickable='state'/'zip code' / 'state and zip code' / 'none'
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - catalog_app_id
* @property {GUID} checkoutId - checkout_id
* @property {number} itemsCount - Numbers of items in cart
* @property {GUID} ecomId - ecom_id
* @property {string} flowType - 'quick flow' / 'full flow'
* @property {boolean} hasGiftCard - payment stage only - true  if visitor sees the Gift Card Checkbox
* @property {boolean} isFirstTimeUsage - True If the user sees this stage for the first time, false if it's from edit click
* @property {boolean} isGiftCardApplied - payment stage only  - true if giftcard is already applied on load
* @property {boolean} isCartPaidOnlyWithGiftCard - True if payments options are hidden due to gift card fully cover the payment (with coupon or without)
* @property {boolean} is_member - true if the visitor signed in as a member, false otherwise
* @property {boolean} isOwner - true if visitor is the site owner
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} num_of_shipping - number of shipping choices presented to the visitor
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {string} origin - 'OA StoreFront' (for OneApp)
* @property {GUID} owner_id - uuid of site owner
* @property {boolean} savedAddress - true if the member has saved address
* @property {string} shippingMethodType - shipping / store pickup or pickup  / none
* @property {string} shippingStatus - data on shipping status from shipping service, only relevant after shipping details were field
* @property {string} stage - which stage in the wishlist installation process
* @property {string} validationMessage - JSON with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
* @property {string} validationSpi - jason with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
**/
/**
 * Name: Checkout -> specific stage expanded. Evid: 37.
 * Event description: when a new stage is expanded and another collapse.
When all data is visible. since june 2019 is sent also from OneApp.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * additionalRequiredField - Type: string. Desc: only for 'placeOrderFastFlow' stage: required additional field that we didnt get info fron PayPal) for "Place Order" button to be clickable='state'/'zip code' / 'state and zip code' / 'none'
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: catalog_app_id
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * itemsCount - Type: numeric. Desc: Numbers of items in cart
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * flowType - Type: string. Desc: 'quick flow' / 'full flow'
 *
 * hasGiftCard - Type: bool. Desc: payment stage only - true  if visitor sees the Gift Card Checkbox
 *
 * isFirstTimeUsage - Type: bool. Desc: True If the user sees this stage for the first time, false if it's from edit click
 *
 * isGiftCardApplied - Type: bool. Desc: payment stage only  - true if giftcard is already applied on load
 *
 * isCartPaidOnlyWithGiftCard - Type: bool. Desc: True if payments options are hidden due to gift card fully cover the payment (with coupon or without)
 *
 * is_member - Type: bool. Desc: true if the visitor signed in as a member, false otherwise
 *
 * isOwner - Type: bool. Desc: true if visitor is the site owner
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * origin - Type: string. Desc: 'OA StoreFront' (for OneApp)
 *
 * owner_id - Type: guid. Desc: uuid of site owner
 *
 * savedAddress - Type: bool. Desc: true if the member has saved address
 *
 * shippingMethodType - Type: string. Desc: shipping / store pickup or pickup  / none
 *
 * shippingStatus - Type: string. Desc: data on shipping status from shipping service, only relevant after shipping details were field
 *
 * stage - Type: string. Desc: which stage in the wishlist installation process
 *
 * validationMessage - Type: string. Desc: JSON with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
 *
 * validationSpi - Type: string. Desc: jason with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
 * @param {checkoutPageSpecificStageExpandedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutPageSpecificStageExpanded = function (params) {
    return { evid: 37, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} oaDebugGeneralEventParams
* @property {string} info - debug info
* @property {string} name - what for event is sent
**/
/**
 * Name: OA debug -> general event. Evid: 458.
 * Event description: event for debuging.

 * info - Type: string. Desc: debug info
 *
 * name - Type: string. Desc: what for event is sent
 * @param {oaDebugGeneralEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var oaDebugGeneralEvent = function (params) {
    return { evid: 458, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutNotAbleToAcceptPaymentsVisitorPopupSfParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - app_name
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - Should be taken from checkout.Checkout Object.checkoutId
* @property {GUID} ecomId - ecom_id
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {string} origin - null
* @property {string} viewMode - editor / live / preview
**/
/**
 * Name: Checkout -> Not able to accept payments visitor popup SF. Evid: 283.
 * Event description: Error pop-up opens when the buyer clicks on one of the checkout buttons, and If the store can't accept orders (not an Active Store / doesn't have any shipping rules)..

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string. Desc: app_name
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: Should be taken from checkout.Checkout Object.checkoutId
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * origin - Type: string.
 *
 * viewMode - Type: string. Desc: editor / live / preview
 * @param {checkoutNotAbleToAcceptPaymentsVisitorPopupSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutNotAbleToAcceptPaymentsVisitorPopupSf = function (params) {
    return { evid: 283, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickToAddCouponParams
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {boolean} isMember - true if visitor is member
* @property {boolean} isOwner - true if visitor is the site owner
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {string} origin - shopping cart / checkout
* @property {GUID} owner_id - uuid of site owner
**/
/**
 * Name: Checkout -> Click to add Coupon. Evid: 111.
 * Event description: user clicks on "add code"/"insert promo code" (first step of applying coupon) . since june 2019 also sent from OA StoreFront (member view).

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isMember - Type: bool. Desc: true if visitor is member
 *
 * isOwner - Type: bool. Desc: true if visitor is the site owner
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * origin - Type: string. Desc: shopping cart / checkout
 *
 * owner_id - Type: guid. Desc: uuid of site owner
 * @param {clickToAddCouponParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickToAddCoupon = function (params) {
    return { evid: 111, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickPlaceOrderWithSubscriptionParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {boolean} default_state - true if was turned on by default by merchant settings
* @property {GUID} ecomId - ecom_id
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {string} origin - OA StoreFront
**/
/**
 * Name: Checkout -> Click Place order with Subscription. Evid: 58.
 * Event description: if mail "Subscription" checkbox was checked on clicking on place order (client event). since june 2019 also sent from OA StoreFront (with origin).

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * default_state - Type: bool. Desc: true if was turned on by default by merchant settings
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * origin - Type: string. Desc: OA StoreFront
 * @param {clickPlaceOrderWithSubscriptionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickPlaceOrderWithSubscription = function (params) {
    return { evid: 58, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} thankYouPageContinueBrowsingLinkClickedSfParams
* @property {string} appName - null
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {string} checkoutId - Order.checkoutId
* @property {GUID} ecomId - ecom_id
* @property {string} orderId - orderId
**/
/**
 * Name: Thank you page-> Continue browsing link clicked SF. Evid: 176.


 * appName - Type: string.
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: string. Desc: Order.checkoutId
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * orderId - Type: string. Desc: orderId
 * @param {thankYouPageContinueBrowsingLinkClickedSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thankYouPageContinueBrowsingLinkClickedSf = function (params) {
    return { evid: 176, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutTipsTipAddedToCheckoutParams
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {boolean} isCustomTip - True - custom amount False - option from list
* @property {number} rate - The tip value * 100000
* @property {string} tipType - Percentage/Fixed amount
**/
/**
 * Name: Checkout Tips ->  Tip added to checkout. Evid: 834.
 * Event description: When a visitor adds a tip in the checkout (or - changes the default setting)_.

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isCustomTip - Type: bool. Desc: True - custom amount False - option from list
 *
 * rate - Type: numeric. Desc: The tip value * 100000
 *
 * tipType - Type: string. Desc: Percentage/Fixed amount
 * @param {checkoutTipsTipAddedToCheckoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutTipsTipAddedToCheckout = function (params) {
    return { evid: 834, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} errorInCheckoutParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order. not exist in OOI checkout
* @property {string} appName - app_name
* @property {string} buyerLanguage - buyer Language. not exist in OOI checkout
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - list of all catalog app ids. A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {string} channelType - what is the channel type
* @property {GUID} checkoutId - checkout_id
* @property {string} contactId - Buyer's contact ID. take from: Checkout.Chekout object.buyerInfo.contactId
* @property {string} customFieldsTitle - title of custom field (can be a list if there is more than one field
* @property {number} dintinctNumItems - count distinct item_id. not exist in OOI checkout
* @property {string} dintinctNumItemsPerCatalog - Json - sum of total count distinct item_id per catalog - example: {“stores”: 2, “bookings”: 3}. not exist in OOI checkout
* @property {GUID} ecomId - ecom_id
* @property {string} errorMessage - right now only relevant for minimum order, no message = NULL
* @property {string} field - Icon text, button text, out of stock...
* @property {string} flowType - 'quick flow' / 'full flow'. For OOI Checkout- fastFlow = 'fast flow', visitorPickupFlow = 'visitor pickup flow', memberPickupFlow = 'member pickup flow', visitorShippingFlow = 'visitor shipping flow', memberShippingFlow = 'member shipping flow', nonShippableFlow = 'non shippable flow', unrecognizedFlow = 'unrecognized Flow',
* @property {boolean} isBuyNowPayLaterOption - is buy now pay later option exist. not exit in OOI checkout
* @property {boolean} isBuyerNote - does a buyes note exist. not exit in OOI checkout
* @property {boolean} isCalculationErrors - does calculation errors exist.
* @property {boolean} isDiscountPriceSummary - does discount exist in price summary. not exit in OOI checkout
* @property {boolean} isGiftCard - does gift card is available in the checkout
* @property {boolean} isMember - true if visitor is member
* @property {boolean} isOwner - true if visitor is the site owner
* @property {boolean} isPolicy - has policies in checkout
* @property {boolean} is_promo_code - is promo code (coupon) option visible in the cart & checkout
* @property {boolean} isShippingPriceSummary - does shipping exist in price summary. not exit in OOI checkout
* @property {boolean} isTaxPriceSummary - does tax exist in price summary. not exit in OOI checkout
* @property {boolean} is_with_ewallet_payment - does the store has an ewallet payment connected
* @property {boolean} is_with_offline_payment - does the store has an offline payment connected
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} itemsQuantity - sum of total items quantity. not exit in OOI checkout
* @property {string} itemsQuantityPerCatalog - Json - sum of total items quantity per catalog - example: {“stores”: 9, “bookings”: 7}. not exit in OOI checkout
* @property {string} message - validation error
* @property {number} numLineItems - total number of line items. not exit in OOI checkout
* @property {string} numLineItemsPerCatalog - Json - number of line items per catalog - example: {“stores”: 3, “bookings”: 4}. not exit in OOI checkout
* @property {number} num_of_paymet_providers - How many payment providers does the store/ site has connected. not exit in OOI checkout
* @property {number} num_of_shipping - number of shipping choices presented to the visitor. not exit in OOI checkout
* @property {number} numberOfAdditionalFees - number of all additional fees in the order. not exit in OOI checkout
* @property {string} origin - OA StoreFront
* @property {string} originType - the type of flow that lead to the checkout, like buy now, paypal, etc.
* @property {GUID} owner_id - uuid of site owner
* @property {string} paymet_providers - array of payment providers connected to the store site. not exit in OOI checkout
* @property {boolean} savedAddress - true if the member has saved address. not exit in OOI checkout
* @property {string} selectedCarrierServiceOption - Take from: Checkout.Chekout object.Shipping Info.selectedCarrierServiceOption. not exit in OOI checkout
* @property {string} selectedDeliveryOption - what was the selected delivery option.. not exit in OOI checkout
* @property {string} shippingCity - buyer city when viewing the checkout. Take from: Checkout.Chekout object.Shipping Info. shipping destenation.address.city. not exit in OOI checkout
* @property {string} shippingCountry - buyer country code when viewing the checkout. Take from: Checkout.Chekout object.Shipping Info. shipping destenation.address.country. not exit in OOI checkout
* @property {string} shippingMethodType - shipping /store pickup / none. not exit in OOI checkout
* @property {string} siteLanguage - site Language. not exit in OOI checkout
* @property {string} stage - which stage in the wishlist installation process
* @property {string} validationMessage - JSON with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
**/
/**
 * Name: Checkout -> Error in checkout. Evid: 24.
 * Event description: errors in checkoutfunnel. since june 2019 also sent from OneApp (origin = 'OA StoreFront').

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order. not exist in OOI checkout
 *
 * appName - Type: string. Desc: app_name
 *
 * buyerLanguage - Type: string. Desc: buyer Language. not exist in OOI checkout
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: list of all catalog app ids. A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * channelType - Type: string. Desc: what is the channel type
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * contactId - Type: string. Desc: Buyer's contact ID. take from: Checkout.Chekout object.buyerInfo.contactId
 *
 * customFieldsTitle - Type: string. Desc: title of custom field (can be a list if there is more than one field
 *
 * dintinctNumItems - Type: numeric. Desc: count distinct item_id. not exist in OOI checkout
 *
 * dintinctNumItemsPerCatalog - Type: string. Desc: Json - sum of total count distinct item_id per catalog - example: {“stores”: 2, “bookings”: 3}. not exist in OOI checkout
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * errorMessage - Type: string. Desc: right now only relevant for minimum order, no message = NULL
 *
 * field - Type: string. Desc: Icon text, button text, out of stock...
 *
 * flowType - Type: string. Desc: 'quick flow' / 'full flow'. For OOI Checkout- fastFlow = 'fast flow', visitorPickupFlow = 'visitor pickup flow', memberPickupFlow = 'member pickup flow', visitorShippingFlow = 'visitor shipping flow', memberShippingFlow = 'member shipping flow', nonShippableFlow = 'non shippable flow', unrecognizedFlow = 'unrecognized Flow',
 *
 * isBuyNowPayLaterOption - Type: bool. Desc: is buy now pay later option exist. not exit in OOI checkout
 *
 * isBuyerNote - Type: bool. Desc: does a buyes note exist. not exit in OOI checkout
 *
 * isCalculationErrors - Type: bool. Desc: does calculation errors exist.
 *
 * isDiscountPriceSummary - Type: bool. Desc: does discount exist in price summary. not exit in OOI checkout
 *
 * isGiftCard - Type: bool. Desc: does gift card is available in the checkout
 *
 * isMember - Type: bool. Desc: true if visitor is member
 *
 * isOwner - Type: bool. Desc: true if visitor is the site owner
 *
 * isPolicy - Type: bool. Desc: has policies in checkout
 *
 * is_promo_code - Type: bool. Desc: is promo code (coupon) option visible in the cart & checkout
 *
 * isShippingPriceSummary - Type: bool. Desc: does shipping exist in price summary. not exit in OOI checkout
 *
 * isTaxPriceSummary - Type: bool. Desc: does tax exist in price summary. not exit in OOI checkout
 *
 * is_with_ewallet_payment - Type: bool. Desc: does the store has an ewallet payment connected
 *
 * is_with_offline_payment - Type: bool. Desc: does the store has an offline payment connected
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * itemsQuantity - Type: numeric. Desc: sum of total items quantity. not exit in OOI checkout
 *
 * itemsQuantityPerCatalog - Type: string. Desc: Json - sum of total items quantity per catalog - example: {“stores”: 9, “bookings”: 7}. not exit in OOI checkout
 *
 * message - Type: string. Desc: validation error
 *
 * numLineItems - Type: numeric. Desc: total number of line items. not exit in OOI checkout
 *
 * numLineItemsPerCatalog - Type: string. Desc: Json - number of line items per catalog - example: {“stores”: 3, “bookings”: 4}. not exit in OOI checkout
 *
 * num_of_paymet_providers - Type: numeric. Desc: How many payment providers does the store/ site has connected. not exit in OOI checkout
 *
 * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor. not exit in OOI checkout
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order. not exit in OOI checkout
 *
 * origin - Type: string. Desc: OA StoreFront
 *
 * originType - Type: string. Desc: the type of flow that lead to the checkout, like buy now, paypal, etc.
 *
 * owner_id - Type: guid. Desc: uuid of site owner
 *
 * paymet_providers - Type: string. Desc: array of payment providers connected to the store site. not exit in OOI checkout
 *
 * savedAddress - Type: bool. Desc: true if the member has saved address. not exit in OOI checkout
 *
 * selectedCarrierServiceOption - Type: string. Desc: Take from: Checkout.Chekout object.Shipping Info.selectedCarrierServiceOption. not exit in OOI checkout
 *
 * selectedDeliveryOption - Type: string. Desc: what was the selected delivery option.. not exit in OOI checkout
 *
 * shippingCity - Type: string. Desc: buyer city when viewing the checkout. Take from: Checkout.Chekout object.Shipping Info. shipping destenation.address.city. not exit in OOI checkout
 *
 * shippingCountry - Type: string. Desc: buyer country code when viewing the checkout. Take from: Checkout.Chekout object.Shipping Info. shipping destenation.address.country. not exit in OOI checkout
 *
 * shippingMethodType - Type: string. Desc: shipping /store pickup / none. not exit in OOI checkout
 *
 * siteLanguage - Type: string. Desc: site Language. not exit in OOI checkout
 *
 * stage - Type: string. Desc: which stage in the wishlist installation process
 *
 * validationMessage - Type: string. Desc: JSON with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
 * @param {errorInCheckoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var errorInCheckout = function (params) {
    return { evid: 24, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} updateClickedInSelectYourShippingDestinationPopupSfParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in cart
* @property {string} appName - app_name
* @property {GUID} cartId - cart id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} checkoutId - checkout_id
* @property {boolean} hasZipCode - true if the destination was saved with zip code, else false
* @property {number} numberOfAdditionalFees - number of all additional fees in the cart
* @property {string} shippingDestinationCountry - shipping destination country
* @property {string} shippingDestinationState - shipping destination state
**/
/**
 * Name: Cart -> update was clicked in select your shipping destination popup SF. Evid: 125.
 * Event description: When a visitor clicks on one of the options in the shipping method dropdown on the cart page.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in cart
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * hasZipCode - Type: bool. Desc: true if the destination was saved with zip code, else false
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the cart
 *
 * shippingDestinationCountry - Type: string. Desc: shipping destination country
 *
 * shippingDestinationState - Type: string. Desc: shipping destination state
 * @param {updateClickedInSelectYourShippingDestinationPopupSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var updateClickedInSelectYourShippingDestinationPopupSf = function (params) {
    return { evid: 125, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutRedirectFromOoiCheckoutForDevParams
* @property {GUID} checkoutId - The checkout_id won't sent when the reason is not fast flow
* @property {string} reason - reason for the redirect (non-english, non-stores)
**/
/**
 * Name: Checkout -> Redirect from OOI Checkout (for dev). Evid: 718.
 * Event description: When UoU is redirected from the OOI checkout to the old Checkout (non-English/have bookings).

 * checkoutId - Type: guid. Desc: The checkout_id won't sent when the reason is not fast flow
 *
 * reason - Type: string. Desc: reason for the redirect (non-english, non-stores)
 * @param {checkoutRedirectFromOoiCheckoutForDevParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutRedirectFromOoiCheckoutForDev = function (params) {
    return { evid: 718, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} cartMiniCartLoadedParams
* @property {string} appName - app_name
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
**/
/**
 * Name: Cart -> Mini Cart loaded. Evid: 211.
 * Event description: Mini Cart loaded.

 * appName - Type: string. Desc: app_name
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 * @param {cartMiniCartLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartMiniCartLoaded = function (params) {
    return { evid: 211, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutOoiDevsQaEventParams
* @property {string} dataString - field with string to check
**/
/**
 * Name: Checkout OOI- devs QA event. Evid: 707.
 * Event description: this bi event is for the devs QA checks.

 * dataString - Type: string. Desc: field with string to check
 * @param {checkoutOoiDevsQaEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutOoiDevsQaEvent = function (params) {
    return { evid: 707, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickOnEditCartParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - null
* @property {GUID} cartId - null
* @property {string} cartType - null
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {string} origin - null
**/
/**
 * Name: Checkout -> click on edit cart. Evid: 171.
 * Event description: click on edit cart button in checkout process.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string.
 *
 * cartId - Type: guid.
 *
 * cartType - Type: string.
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * origin - Type: string.
 * @param {clickOnEditCartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnEditCart = function (params) {
    return { evid: 171, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutClickLoginInCheckoutParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {string} flowType - 'quick flow' / 'full flow'
* @property {boolean} is_member - true if the visitor signed in as a member, false otherwise
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {GUID} owner_id - owner_id
* @property {boolean} savedAddress - true if the member has saved address
**/
/**
 * Name: Checkout -> click login in checkout. Evid: 604.
 * Event description: When site member clicks to login in checkout
Until the 26.2.23 the event was sent as:
5:601 Site Members - Click on Login/Sign Button up for site members.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * flowType - Type: string. Desc: 'quick flow' / 'full flow'
 *
 * is_member - Type: bool. Desc: true if the visitor signed in as a member, false otherwise
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * owner_id - Type: guid. Desc: owner_id
 *
 * savedAddress - Type: bool. Desc: true if the member has saved address
 * @param {checkoutClickLoginInCheckoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutClickLoginInCheckout = function (params) {
    return { evid: 604, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} membersAddressInCheckoutWasChangedParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {string} origin - addresses list / add address / edit address
* @property {string} stage - which stage the address was changed (payment/shipping..)
**/
/**
 * Name: members -> address in checkout was changed. Evid: 48.
 * Event description: when address was changed in the checkout.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * origin - Type: string. Desc: addresses list / add address / edit address
 *
 * stage - Type: string. Desc: which stage the address was changed (payment/shipping..)
 * @param {membersAddressInCheckoutWasChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var membersAddressInCheckoutWasChanged = function (params) {
    return { evid: 48, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} editorClickOnLeftBarTabsOnComponentSettingsSfeParams
* @property {string} appName - app_name
* @property {string} component_id - grid gallery, slider galeery, product page, CurrencyConverter, AvalaraTax
* @property {boolean} isPremiumEligible - Does the site have a premium package that allows using the feature (if not relevant null)
* @property {string} origin - the state of the panel when the user clicked on the button
* @property {string} tab - null
**/
/**
 * Name: Editor-> click on left bar tabs on component settings  SFE. Evid: 33.
 * Event description: click to view tab in the settings component (left bar).

 * appName - Type: string. Desc: app_name
 *
 * component_id - Type: string. Desc: grid gallery, slider galeery, product page, CurrencyConverter, AvalaraTax
 *
 * isPremiumEligible - Type: bool. Desc: Does the site have a premium package that allows using the feature (if not relevant null)
 *
 * origin - Type: string. Desc: the state of the panel when the user clicked on the button
 *
 * tab - Type: string.
 * @param {editorClickOnLeftBarTabsOnComponentSettingsSfeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorClickOnLeftBarTabsOnComponentSettingsSfe = function (params) {
    return { evid: 33, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} oneAppStoreFrontClearCartSfParams
* @property {string} cartId - cartId
* @property {string} catalogAppId - Stores/bookings App id
* @property {number} itemsCount - # of products in cart
**/
/**
 * Name: OneApp StoreFront -> Clear cart SF. Evid: 184.
 * Event description: OneApp StoreFront -> Clear cart SF.

 * cartId - Type: string. Desc: cartId
 *
 * catalogAppId - Type: string. Desc: Stores/bookings App id
 *
 * itemsCount - Type: numeric. Desc: # of products in cart
 * @param {oneAppStoreFrontClearCartSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var oneAppStoreFrontClearCartSf = function (params) {
    return { evid: 184, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutMinimumOrderModalIsShownInCheckoutParams
* @property {string} appName - null
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - only in EP
* @property {string} currency - the currency that was shown in the message
* @property {number} diffLong - The diff between the relevant order value and the minimum order threshold  multiplied by 100,000
* @property {GUID} ecomId - ecom_id
* @property {boolean} hasPickup - has_pickup
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} minimumValueLong - the minimum order threshold multiplied by 100,000
* @property {string} stage - the stage in the checkout the visitor was at when the modal was opened
**/
/**
 * Name: Checkout -> Minimum order modal is shown in checkout. Evid: 654.
 * Event description: Minimum order modal is shown in checkout.

 * appName - Type: string.
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: only in EP
 *
 * currency - Type: string. Desc: the currency that was shown in the message
 *
 * diffLong - Type: numeric. Desc: The diff between the relevant order value and the minimum order threshold  multiplied by 100,000
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * hasPickup - Type: bool. Desc: has_pickup
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * minimumValueLong - Type: numeric. Desc: the minimum order threshold multiplied by 100,000
 *
 * stage - Type: string. Desc: the stage in the checkout the visitor was at when the modal was opened
 * @param {checkoutMinimumOrderModalIsShownInCheckoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutMinimumOrderModalIsShownInCheckout = function (params) {
    return { evid: 654, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} shippingAddressSetParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {boolean} isChecked - is billing address the same as delivery address
* @property {boolean} isFormValid - is form valid (all mandatory fields are compatible)
* @property {boolean} isOwner - true if visitor is the site owner
* @property {string} item_type - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {GUID} owner_id - uuid of site owner
**/
/**
 * Name: Checkout -> Shipping address set. Evid: 161.
 * Event description: Shipping address set. since june 2019 is also sentt from OneApp (origin =OA StoreFront).

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isChecked - Type: bool. Desc: is billing address the same as delivery address
 *
 * isFormValid - Type: bool. Desc: is form valid (all mandatory fields are compatible)
 *
 * isOwner - Type: bool. Desc: true if visitor is the site owner
 *
 * item_type - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * owner_id - Type: guid. Desc: uuid of site owner
 * @param {shippingAddressSetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var shippingAddressSet = function (params) {
    return { evid: 161, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} editorChangeTextFieldSfeParams
* @property {string} appName - null
* @property {string} component_id - grid gallery, slider galery, product page, mini cart....
* @property {string} field - Icon text, button text, out of stock...
* @property {string} origin - the state of the panel when the user clicked on the button
* @property {string} text - custom filter name
**/
/**
 * Name: Editor-> Change text field SFE. Evid: 833.
 * Event description: change the text in store front settings.

 * appName - Type: string.
 *
 * component_id - Type: string. Desc: grid gallery, slider galery, product page, mini cart....
 *
 * field - Type: string. Desc: Icon text, button text, out of stock...
 *
 * origin - Type: string. Desc: the state of the panel when the user clicked on the button
 *
 * text - Type: string. Desc: custom filter name
 * @param {editorChangeTextFieldSfeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorChangeTextFieldSfe = function (params) {
    return { evid: 833, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} saveNoteToSellerSfParams
* @property {string} appName - app_name
* @property {GUID} cartId - cart id
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {boolean} is_empty - is text field empty
* @property {string} origin - origin
**/
/**
 * Name: Cart -> Save note to seller SF. Evid: 122.
 * Event description: buyer clicks on 'done' in add note to seller field in cart page. since june 2019 also sent from OA StoreFront (with origin).

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * is_empty - Type: bool. Desc: is text field empty
 *
 * origin - Type: string. Desc: origin
 * @param {saveNoteToSellerSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var saveNoteToSellerSf = function (params) {
    return { evid: 122, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} editorOpenAppSettingsSfeParams
* @property {string} appName - app_name
* @property {string} component_id - CurAvalaraTax, grid gallery, slider gallery, product page, CurrencyConverter
* @property {string} editorMode - mobile / desktop
* @property {boolean} isPremiumEligible - Does the site have a premium package that allows using the feature (if not relevant null)
* @property {string} origin - the state of the panel when the user clicked on the button:editor / onboarding /editorX…
**/
/**
 * Name: Editor-> open app settings SFE. Evid: 811.
 * Event description: double click / right click on a wixstores component.

 * appName - Type: string. Desc: app_name
 *
 * component_id - Type: string. Desc: CurAvalaraTax, grid gallery, slider gallery, product page, CurrencyConverter
 *
 * editorMode - Type: string. Desc: mobile / desktop
 *
 * isPremiumEligible - Type: bool. Desc: Does the site have a premium package that allows using the feature (if not relevant null)
 *
 * origin - Type: string. Desc: the state of the panel when the user clicked on the button:editor / onboarding /editorX…
 * @param {editorOpenAppSettingsSfeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorOpenAppSettingsSfe = function (params) {
    return { evid: 811, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} viewCartPageSfParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in cart
* @property {string} appName - app_name
* @property {GUID} cartId - cart id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} checkoutId - checkout_id
* @property {string} checkoutType - in viewer / out of viewer
* @property {number} itemsCount - number of items in the cart
* @property {GUID} ecomId - ecom_id
* @property {boolean} isContinueShopping - show continue shopping link in cart
* @property {boolean} isDeliveryRates - show delivery rates in cart
* @property {boolean} isFullWidth - is the full width setting in the cart on / off
* @property {boolean} is_member - true is the visitor signed in as a member, false otherwise
* @property {boolean} isMembersInstalled - true if members app installed on site, false otherwise
* @property {boolean} is_note - show add a note to seller in cart
* @property {boolean} isOwner - true for owner false for member. since june 2019
* @property {boolean} isPickupAvailable - is pickup available
* @property {boolean} is_promo_code - show/hide promo code (coupon) in the cart & checkout
* @property {boolean} isShippingCalculated - is the shipping estimation is calculated
* @property {boolean} isTaxCosts - show tax costs in cart
* @property {boolean} is_with_ewallet_payment - does the store has an ewallet payment connected (and displaying in cart)
* @property {boolean} is_with_offline_payment - does the store has an offline payment connected
* @property {number} lineItemsCount - number of line items in cart
* @property {number} num_of_paymet_providers - How many payment providers does the store has connected
* @property {number} num_of_shipping - number of shipping choices presented to the visitor at the first time
* @property {number} numberOfAdditionalFees - number of all additional fees in the cart
* @property {string} origin - add to cart / mini cart / cart widget / checkout / 'eWallet redirect - cancel'
* @property {GUID} owner_id - id of site's owner. since june 2019
* @property {string} paymet_providers - array of payment providers connected to the store
* @property {string} shippingReason - the reason why the shipping is not calculated (unknown = POS/digital cart)
* @property {GUID} siteMemberId - member guid
* @property {GUID} uuid - uuid
* @property {string} validationMessage - JSON with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
* @property {string} validationSpi - jason with the validation that appear in the cart while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
* @property {string} viewMode - editor / site / preview
* @property {GUID} visitorId - visitorId
**/
/**
 * Name: Cart -> view cart page SF. Evid: 124.
 * Event description: view cart page. since june 2019 also for OneApp Store front.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in cart
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * checkoutType - Type: string. Desc: in viewer / out of viewer
 *
 * itemsCount - Type: numeric. Desc: number of items in the cart
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isContinueShopping - Type: bool. Desc: show continue shopping link in cart
 *
 * isDeliveryRates - Type: bool. Desc: show delivery rates in cart
 *
 * isFullWidth - Type: bool. Desc: is the full width setting in the cart on / off
 *
 * is_member - Type: bool. Desc: true is the visitor signed in as a member, false otherwise
 *
 * isMembersInstalled - Type: bool. Desc: true if members app installed on site, false otherwise
 *
 * is_note - Type: bool. Desc: show add a note to seller in cart
 *
 * isOwner - Type: bool. Desc: true for owner false for member. since june 2019
 *
 * isPickupAvailable - Type: bool. Desc: is pickup available
 *
 * is_promo_code - Type: bool. Desc: show/hide promo code (coupon) in the cart & checkout
 *
 * isShippingCalculated - Type: bool. Desc: is the shipping estimation is calculated
 *
 * isTaxCosts - Type: bool. Desc: show tax costs in cart
 *
 * is_with_ewallet_payment - Type: bool. Desc: does the store has an ewallet payment connected (and displaying in cart)
 *
 * is_with_offline_payment - Type: bool. Desc: does the store has an offline payment connected
 *
 * lineItemsCount - Type: numeric. Desc: number of line items in cart
 *
 * num_of_paymet_providers - Type: numeric. Desc: How many payment providers does the store has connected
 *
 * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor at the first time
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the cart
 *
 * origin - Type: string. Desc: add to cart / mini cart / cart widget / checkout / 'eWallet redirect - cancel'
 *
 * owner_id - Type: guid. Desc: id of site's owner. since june 2019
 *
 * paymet_providers - Type: string. Desc: array of payment providers connected to the store
 *
 * shippingReason - Type: string. Desc: the reason why the shipping is not calculated (unknown = POS/digital cart)
 *
 * siteMemberId - Type: guid. Desc: member guid
 *
 * uuid - Type: guid. Desc: uuid
 *
 * validationMessage - Type: string. Desc: JSON with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
 *
 * validationSpi - Type: string. Desc: jason with the validation that appear in the cart while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
 *
 * viewMode - Type: string. Desc: editor / site / preview
 *
 * visitorId - Type: guid. Desc: visitorId
 * @param {viewCartPageSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var viewCartPageSf = function (params) {
    return { evid: 124, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutMemberClickOnEditMemberAddressParams
* @property {GUID} addressServiceId - aaddress_id
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical) etc
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} origin - from where the visitor clicked on edit/change address - dropdown / error message
* @property {string} stage - in which stage the visitor clicked on edit/change address - contact-details or billing
**/
/**
 * Name: Checkout Member ->  Click on Edit Member Address. Evid: 827.
 * Event description: when a member clicks on edit/change member address.

 * addressServiceId - Type: guid. Desc: aaddress_id
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical) etc
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * origin - Type: string. Desc: from where the visitor clicked on edit/change address - dropdown / error message
 *
 * stage - Type: string. Desc: in which stage the visitor clicked on edit/change address - contact-details or billing
 * @param {checkoutMemberClickOnEditMemberAddressParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutMemberClickOnEditMemberAddress = function (params) {
    return { evid: 827, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} ordersViewOrderDetailsPageSfParams
* @property {string} appName - app_name
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - list of all catalog app ids
* @property {string} contact_id - contact_id
* @property {number} itemsCount - number of items in the order
* @property {string} orderId - orderId
* @property {string} origin - order_page
* @property {GUID} site_member_id - member id
**/
/**
 * Name: Orders ->  view order_details page SF. Evid: 128.
 * Event description: view order details in order history page.

 * appName - Type: string. Desc: app_name
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: list of all catalog app ids
 *
 * contact_id - Type: string. Desc: contact_id
 *
 * itemsCount - Type: numeric. Desc: number of items in the order
 *
 * orderId - Type: string. Desc: orderId
 *
 * origin - Type: string. Desc: order_page
 *
 * site_member_id - Type: guid. Desc: member id
 * @param {ordersViewOrderDetailsPageSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ordersViewOrderDetailsPageSf = function (params) {
    return { evid: 128, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} giftCardCheckoutClickApplyParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - null
* @property {GUID} cartId - cart id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {boolean} isMember - true if visitor is member
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
**/
/**
 * Name: gift card checkout -> click Apply. Evid: 529.
 * Event description: when visitor checks / unchecks the Gift Card checkbox in Payment stage of Checkout.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string.
 *
 * cartId - Type: guid. Desc: cart id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isMember - Type: bool. Desc: true if visitor is member
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 * @param {giftCardCheckoutClickApplyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var giftCardCheckoutClickApply = function (params) {
    return { evid: 529, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} ordersViewOrderHistoryPageSfParams
* @property {string} appName - app_name
* @property {string} catalogAppId - list of all catalog app ids
* @property {string} contact_id - contact_id
* @property {number} itemsCount - number of orders in the page (for without orders it will be 0)
* @property {string} origin - origin
* @property {GUID} site_member_id - member id
**/
/**
 * Name: Orders -> view order_history page SF. Evid: 127.
 * Event description: view order history page (when it is with orders or without).

 * appName - Type: string. Desc: app_name
 *
 * catalogAppId - Type: string. Desc: list of all catalog app ids
 *
 * contact_id - Type: string. Desc: contact_id
 *
 * itemsCount - Type: numeric. Desc: number of orders in the page (for without orders it will be 0)
 *
 * origin - Type: string. Desc: origin
 *
 * site_member_id - Type: guid. Desc: member id
 * @param {ordersViewOrderHistoryPageSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ordersViewOrderHistoryPageSf = function (params) {
    return { evid: 127, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutShowMerchantPaymentPopupSfParams
* @property {string} appName - app_name
* @property {string} catalogAppId - list of all catalog app ids
* @property {GUID} ecomId - ecom_id
* @property {string} mode - mode
* @property {string} origin - where the modal pops up (cart / product page...)
**/
/**
 * Name: Checkout -> Show merchant payment popup SF. Evid: 164.
 * Event description: When the user connects to his site and tries to do checkout when the payment method doesn't define in the site's settings.

 * appName - Type: string. Desc: app_name
 *
 * catalogAppId - Type: string. Desc: list of all catalog app ids
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * mode - Type: string. Desc: mode
 *
 * origin - Type: string. Desc: where the modal pops up (cart / product page...)
 * @param {checkoutShowMerchantPaymentPopupSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutShowMerchantPaymentPopupSf = function (params) {
    return { evid: 164, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} selectPaymentCategoryParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {string} paymentCategory - CreditCard/Ewallet
* @property {string} paymentMethod - authorize-net/Stripe
**/
/**
 * Name: Checkout -> Select payment category cashier. Evid: 200.
 * Event description: Select payment category SF cashier - select radio button.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * paymentCategory - Type: string. Desc: CreditCard/Ewallet
 *
 * paymentMethod - Type: string. Desc: authorize-net/Stripe
 * @param {selectPaymentCategoryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var selectPaymentCategory = function (params) {
    return { evid: 200, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} cartMinimumOrderMessageIsShownInCartParams
* @property {string} appName - app_name
* @property {boolean} buttonEnabled - true - if the button is enabled false -if button is disabled
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} checkoutId - only in EP
* @property {string} currency - the currency that was shown in the message
* @property {number} diffLong - The diff between the relevant order value and the minimum order threshold multiplied by 10000
* @property {GUID} ecomId - ecom_id
* @property {number} minimumValueLong - the minimum order threshold multiplied by 10000
**/
/**
 * Name: Cart -> Minimum order message is shown in cart. Evid: 653.
 * Event description: Minimum order message is shown in cart.

 * appName - Type: string. Desc: app_name
 *
 * buttonEnabled - Type: bool. Desc: true - if the button is enabled false -if button is disabled
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * checkoutId - Type: guid. Desc: only in EP
 *
 * currency - Type: string. Desc: the currency that was shown in the message
 *
 * diffLong - Type: numeric. Desc: The diff between the relevant order value and the minimum order threshold multiplied by 10000
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * minimumValueLong - Type: numeric. Desc: the minimum order threshold multiplied by 10000
 * @param {cartMinimumOrderMessageIsShownInCartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartMinimumOrderMessageIsShownInCart = function (params) {
    return { evid: 653, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickOnCheckoutParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in cart
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} checkoutId - checkout_id
* @property {number} itemsCount - Numbers of items in cart
* @property {GUID} ecomId - ecom_id
* @property {boolean} is_member - true is the visitor signed in as a member, false otherwise
* @property {boolean} isOwner - true if visitor is the site owner
* @property {boolean} is_with_ewallet_payment - does the store has an ewallet payment connected (and displaying in cart)
* @property {boolean} is_with_offline_payment - does the store has an offline payment connected
* @property {number} num_of_paymet_providers - How many payment providers does the store has connected
* @property {number} num_of_shipping - number of shipping choices presented to the visitor
* @property {number} numberOfAdditionalFees - number of all additional fees in the cart
* @property {string} orig_shipping_method - current shipping method in cart page (free shipping/ Flat rate/ rate by weight/ etc...)
* @property {string} origin - origin
* @property {GUID} owner_id - uuid of site owner
* @property {string} paymet_providers - array of payment providers connected to the store
* @property {string} productsList - json containing all product guids for products in the cart
* @property {string} shippingMethodType - shipping /store pickup / none
* @property {string} validationMessage - jason with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
**/
/**
 * Name: Cart -> Click on checkout. Evid: 114.
 * Event description: Click on checkout from Cart page. since june 2019 also sent from OneApp with origin = 'OA StoreFront'.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in cart
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * itemsCount - Type: numeric. Desc: Numbers of items in cart
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * is_member - Type: bool. Desc: true is the visitor signed in as a member, false otherwise
 *
 * isOwner - Type: bool. Desc: true if visitor is the site owner
 *
 * is_with_ewallet_payment - Type: bool. Desc: does the store has an ewallet payment connected (and displaying in cart)
 *
 * is_with_offline_payment - Type: bool. Desc: does the store has an offline payment connected
 *
 * num_of_paymet_providers - Type: numeric. Desc: How many payment providers does the store has connected
 *
 * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the cart
 *
 * orig_shipping_method - Type: string. Desc: current shipping method in cart page (free shipping/ Flat rate/ rate by weight/ etc...)
 *
 * origin - Type: string. Desc: origin
 *
 * owner_id - Type: guid. Desc: uuid of site owner
 *
 * paymet_providers - Type: string. Desc: array of payment providers connected to the store
 *
 * productsList - Type: string. Desc: json containing all product guids for products in the cart
 *
 * shippingMethodType - Type: string. Desc: shipping /store pickup / none
 *
 * validationMessage - Type: string. Desc: jason with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
 * @param {clickOnCheckoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnCheckout = function (params) {
    return { evid: 114, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} removeACouponParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in cart/order
* @property {string} appName - null
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {string} couponCode - null
* @property {string} couponId - coupon_id
* @property {GUID} ecomId - ecom_id
* @property {boolean} isMember - null
* @property {boolean} isOwner - true if visitor is the site owner
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the cart/order
* @property {string} origin - null
* @property {GUID} owner_id - uuid of site owner
**/
/**
 * Name: Checkout > Remove a coupon. Evid: 118.


 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in cart/order
 *
 * appName - Type: string.
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * couponCode - Type: string.
 *
 * couponId - Type: string. Desc: coupon_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isMember - Type: bool.
 *
 * isOwner - Type: bool. Desc: true if visitor is the site owner
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the cart/order
 *
 * origin - Type: string.
 *
 * owner_id - Type: guid. Desc: uuid of site owner
 * @param {removeACouponParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var removeACoupon = function (params) {
    return { evid: 118, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutMemberMemberAddressCreatedParams
* @property {GUID} addressServiceId - address_id
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical) etc
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {boolean} isSetAsDefaultChecked - true - was checked as default (new default or from last edit)
* @property {string} stage - in which stage the visitor add new address - contact-details or billing
**/
/**
 * Name: Checkout Member ->  Member Address Created. Evid: 824.
 * Event description: when a member adds a new address.

 * addressServiceId - Type: guid. Desc: address_id
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical) etc
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isSetAsDefaultChecked - Type: bool. Desc: true - was checked as default (new default or from last edit)
 *
 * stage - Type: string. Desc: in which stage the visitor add new address - contact-details or billing
 * @param {checkoutMemberMemberAddressCreatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutMemberMemberAddressCreated = function (params) {
    return { evid: 824, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutPageLoadParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - app_name
* @property {string} buyerLanguage - buyer Language. Not exist in OOI checkout
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {string} channelType - what is the channel type (web/back office..)
* @property {GUID} checkoutId - checkout_id
* @property {string} checkoutType - in viewer / out of viewer
* @property {string} contactId - Buyer's contact ID. take from: Checkout.Chekout object.buyerInfo.contactId
* @property {string} customFieldsTitle - title of custom field (can be a list if there is more than one field
* @property {number} dintinctNumItems - count distinct item_id. Not exist in OOI checkout
* @property {string} dintinctNumItemsPerCatalog - Json - sum of total count distinct item_id per catalog - example: {“stores”: 2, “bookings”: 3}. Not exist in OOI checkout
* @property {GUID} ecomId - ecom_id
* @property {string} first_stage - first stage open in checkout page
* @property {string} flowType - 'quick flow' / 'full flow'. For OOI Checkout-   fastFlow = 'fast flow'
* @property {boolean} isBuyNowPayLaterOption - is buy now pay later option exist. Not exist in OOI checkout
* @property {boolean} isBuyerNote - does a buyes note exist. Not exist in OOI checkout
* @property {boolean} isCalculationErrors - does calculation errors exist. Not exist in OOI checkout
* @property {boolean} isDiscountPriceSummary - does discount exist in price summary. Not exist in OOI checkout
* @property {boolean} isGiftCard - does gift card is available in the checkout
* @property {boolean} is_member - true if the visitor signed in as a member, false otherwise
* @property {boolean} isOutOfIframe - only send in the ooi flow. therefore, null = false
* @property {boolean} isOwner - true if visitor is the site owner
* @property {boolean} isPolicy - has policies in checkout
* @property {boolean} is_promo_code - is promo code (coupon) option visible in the cart & checkout
* @property {boolean} isShippingPriceSummary - does shipping exist in price summary
* @property {boolean} isTaxPriceSummary - does tax exist in price summary. Not exist in OOI checkout
* @property {boolean} is_with_ewallet_payment - does the store has an ewallet payment connected
* @property {boolean} is_with_offline_payment - does the store has an offline payment connected
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} itemsQuantity - sum of total items quantity. Not exist in OOI checkout
* @property {string} itemsQuantityPerCatalog - Json - sum of total items quantity per catalog - example: {“stores”: 9, “bookings”: 7}. Not exist in OOI checkout
* @property {number} numLineItems - total number of line items. Not exist in OOI checkout
* @property {string} numLineItemsPerCatalog - Json - number of line items per catalog - example: {“stores”: 3, “bookings”: 4}. Not exist in OOI checkout
* @property {number} num_of_paymet_providers - How many payment providers does the site has connected. Not exist in OOI checkout
* @property {number} num_of_shipping - number of shipping choices presented to the visitor. Not exist in OOI checkout
* @property {number} numberOfAdditionalFees - number of all additional fees in the order. Not exist in OOI checkout
* @property {string} origin - the component / page that the visitor came from to the checkout, like product page, cart page, etc.
* @property {string} originType - the type of flow that lead to the checkout, like buy now, paypal, etc.
* @property {GUID} owner_id - uuid of site owner
* @property {string} paymentProviders - array of payment providers connected to the site - From 1.4.23
* @property {string} paymet_providers - array of payment providers connected to the site - WRONG FIELD
* @property {boolean} savedAddress - true if the member has saved address. Not exist in OOI checkout
* @property {string} selectedCarrierServiceOption - Taken from: Checkout.Chekout object.Shipping Info.selectedCarrierServiceOption. Not exist in OOI checkout
* @property {string} selectedDeliveryOption - what was the selected delivery option. Not exist in OOI checkout
* @property {string} shippingCity - buyer city when viewing the checkout. Not exist in OOI checkout
* @property {string} shippingCountry - buyer country code when viewing the checkout
* @property {string} shippingMethodType - what are the shipping option that are presented(shipping /store pickup / none). Not exist in OOI checkout
* @property {string} siteLanguage - site Language. Not exist in OOI checkout
* @property {string} validationMessage - JSON with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
**/
/**
 * Name: Checkout -> Checkout page load. Evid: 36.
 * Event description: this event indicates witch "checkout page" was presented to the user. there are 6 types that depends on: 1.cart_type : Digital/ Physical/ mixed (Digital &Physical)  2. shipping method : shipping /store pickup / non. 3. flow_type: quick / full.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string. Desc: app_name
 *
 * buyerLanguage - Type: string. Desc: buyer Language. Not exist in OOI checkout
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * channelType - Type: string. Desc: what is the channel type (web/back office..)
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * checkoutType - Type: string. Desc: in viewer / out of viewer
 *
 * contactId - Type: string. Desc: Buyer's contact ID. take from: Checkout.Chekout object.buyerInfo.contactId
 *
 * customFieldsTitle - Type: string. Desc: title of custom field (can be a list if there is more than one field
 *
 * dintinctNumItems - Type: numeric. Desc: count distinct item_id. Not exist in OOI checkout
 *
 * dintinctNumItemsPerCatalog - Type: string. Desc: Json - sum of total count distinct item_id per catalog - example: {“stores”: 2, “bookings”: 3}. Not exist in OOI checkout
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * first_stage - Type: string. Desc: first stage open in checkout page
 *
 * flowType - Type: string. Desc: 'quick flow' / 'full flow'. For OOI Checkout-   fastFlow = 'fast flow'
 *
 * isBuyNowPayLaterOption - Type: bool. Desc: is buy now pay later option exist. Not exist in OOI checkout
 *
 * isBuyerNote - Type: bool. Desc: does a buyes note exist. Not exist in OOI checkout
 *
 * isCalculationErrors - Type: bool. Desc: does calculation errors exist. Not exist in OOI checkout
 *
 * isDiscountPriceSummary - Type: bool. Desc: does discount exist in price summary. Not exist in OOI checkout
 *
 * isGiftCard - Type: bool. Desc: does gift card is available in the checkout
 *
 * is_member - Type: bool. Desc: true if the visitor signed in as a member, false otherwise
 *
 * isOutOfIframe - Type: bool. Desc: only send in the ooi flow. therefore, null = false
 *
 * isOwner - Type: bool. Desc: true if visitor is the site owner
 *
 * isPolicy - Type: bool. Desc: has policies in checkout
 *
 * is_promo_code - Type: bool. Desc: is promo code (coupon) option visible in the cart & checkout
 *
 * isShippingPriceSummary - Type: bool. Desc: does shipping exist in price summary
 *
 * isTaxPriceSummary - Type: bool. Desc: does tax exist in price summary. Not exist in OOI checkout
 *
 * is_with_ewallet_payment - Type: bool. Desc: does the store has an ewallet payment connected
 *
 * is_with_offline_payment - Type: bool. Desc: does the store has an offline payment connected
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * itemsQuantity - Type: numeric. Desc: sum of total items quantity. Not exist in OOI checkout
 *
 * itemsQuantityPerCatalog - Type: string. Desc: Json - sum of total items quantity per catalog - example: {“stores”: 9, “bookings”: 7}. Not exist in OOI checkout
 *
 * numLineItems - Type: numeric. Desc: total number of line items. Not exist in OOI checkout
 *
 * numLineItemsPerCatalog - Type: string. Desc: Json - number of line items per catalog - example: {“stores”: 3, “bookings”: 4}. Not exist in OOI checkout
 *
 * num_of_paymet_providers - Type: numeric. Desc: How many payment providers does the site has connected. Not exist in OOI checkout
 *
 * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor. Not exist in OOI checkout
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order. Not exist in OOI checkout
 *
 * origin - Type: string. Desc: the component / page that the visitor came from to the checkout, like product page, cart page, etc.
 *
 * originType - Type: string. Desc: the type of flow that lead to the checkout, like buy now, paypal, etc.
 *
 * owner_id - Type: guid. Desc: uuid of site owner
 *
 * paymentProviders - Type: string. Desc: array of payment providers connected to the site - From 1.4.23
 *
 * paymet_providers - Type: string. Desc: array of payment providers connected to the site - WRONG FIELD
 *
 * savedAddress - Type: bool. Desc: true if the member has saved address. Not exist in OOI checkout
 *
 * selectedCarrierServiceOption - Type: string. Desc: Taken from: Checkout.Chekout object.Shipping Info.selectedCarrierServiceOption. Not exist in OOI checkout
 *
 * selectedDeliveryOption - Type: string. Desc: what was the selected delivery option. Not exist in OOI checkout
 *
 * shippingCity - Type: string. Desc: buyer city when viewing the checkout. Not exist in OOI checkout
 *
 * shippingCountry - Type: string. Desc: buyer country code when viewing the checkout
 *
 * shippingMethodType - Type: string. Desc: what are the shipping option that are presented(shipping /store pickup / none). Not exist in OOI checkout
 *
 * siteLanguage - Type: string. Desc: site Language. Not exist in OOI checkout
 *
 * validationMessage - Type: string. Desc: JSON with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
 * @param {checkoutPageLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutPageLoad = function (params) {
    return { evid: 36, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickLogoutInCheckoutParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} flowType - 'quick flow' / 'full flow'
* @property {boolean} is_member - true if the visitor signed in as a member, false otherwise
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {GUID} owner_id - null
* @property {boolean} savedAddress - true if the member has saved address
**/
/**
 * Name: Checkout -> click logout in checkout. Evid: 601.
 * Event description: when site member clicks to logout in checkout, opening logout modal.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * flowType - Type: string. Desc: 'quick flow' / 'full flow'
 *
 * is_member - Type: bool. Desc: true if the visitor signed in as a member, false otherwise
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * owner_id - Type: guid.
 *
 * savedAddress - Type: bool. Desc: true if the member has saved address
 * @param {clickLogoutInCheckoutParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickLogoutInCheckout = function (params) {
    return { evid: 601, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} thankYouPageClickOnLinkOnLineItemParams
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {string} catalogItemId - order.lineItems.catalogReference.catalogItemId
* @property {string} checkoutId - Order.checkoutId
* @property {GUID} ecomId - ecom_id
* @property {string} itemType - Order.lineItems.itemType
* @property {string} actionName - Action name (download/print/add to calendar..)
* @property {string} orderId - orderId
**/
/**
 * Name: Thank you page -> click on link on line item. Evid: 175.
 * Event description: When the buyer clicks on one of the item’s links on Thank you page.

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * catalogItemId - Type: string. Desc: order.lineItems.catalogReference.catalogItemId
 *
 * checkoutId - Type: string. Desc: Order.checkoutId
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * itemType - Type: string. Desc: Order.lineItems.itemType
 *
 * actionName - Type: string. Desc: Action name (download/print/add to calendar..)
 *
 * orderId - Type: string. Desc: orderId
 * @param {thankYouPageClickOnLinkOnLineItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var thankYouPageClickOnLinkOnLineItem = function (params) {
    return { evid: 175, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} storesScreenRenderedOaParams
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {boolean} hasPaymentMethod - for orders screen - true if user has at least one payment method connected
* @property {boolean} isOwner - true for merchant, false for member
* @property {boolean} isPremium - for orders screen. true if user is premium (and do not see a bunner to upgrade)
* @property {string} origin - merchantView / memberView / oneAppDashboard
* @property {GUID} owner_id - id of site's owner
* @property {string} pageName - current rendered page (products, orders, product, product_new, order, dashboard, settings, shipping..., tax...)/ cannot_sell / view_store /local delivery / local delivery areas
* @property {string} paymentStatus - paymentStatus
* @property {string} previousPage - where the user came from (stores_home - for tabs in StoresHome, previous page_name for others)
* @property {GUID} id - order id
* @property {string} state - full/empty/filtered
**/
/**
 * Name: Stores screen rendered OA. Evid: 212.
 * Event description: when specific stores screen(product_list, order_list, product, product_new, order) was rendered OneApp. is not sent for rendering coupons.

 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * hasPaymentMethod - Type: bool. Desc: for orders screen - true if user has at least one payment method connected
 *
 * isOwner - Type: bool. Desc: true for merchant, false for member
 *
 * isPremium - Type: bool. Desc: for orders screen. true if user is premium (and do not see a bunner to upgrade)
 *
 * origin - Type: string. Desc: merchantView / memberView / oneAppDashboard
 *
 * owner_id - Type: guid. Desc: id of site's owner
 *
 * pageName - Type: string. Desc: current rendered page (products, orders, product, product_new, order, dashboard, settings, shipping..., tax...)/ cannot_sell / view_store /local delivery / local delivery areas
 *
 * paymentStatus - Type: string. Desc: paymentStatus
 *
 * previousPage - Type: string. Desc: where the user came from (stores_home - for tabs in StoresHome, previous page_name for others)
 *
 * id - Type: guid. Desc: order id
 *
 * state - Type: string. Desc: full/empty/filtered
 * @param {storesScreenRenderedOaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var storesScreenRenderedOa = function (params) {
    return { evid: 212, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutMemberClickOnAddNewAddressParams
* @property {GUID} addressServiceId - address_id
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical) etc
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} origin - from where the uou clicked on add new address - dropdown / error message
* @property {string} stage - in which stage the visitor clicked on add new address - contact-details or billing
**/
/**
 * Name: Checkout Member ->  Click on Add New Address. Evid: 826.
 * Event description: when a member click on create member address (or - add new address).

 * addressServiceId - Type: guid. Desc: address_id
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical) etc
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * origin - Type: string. Desc: from where the uou clicked on add new address - dropdown / error message
 *
 * stage - Type: string. Desc: in which stage the visitor clicked on add new address - contact-details or billing
 * @param {checkoutMemberClickOnAddNewAddressParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutMemberClickOnAddNewAddress = function (params) {
    return { evid: 826, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickOnContinueShoppingFromCartParams
* @property {number} additionalFeesPrice - number of all additional fees in the order
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {string} origin - from cart/checkout page
**/
/**
 * Name: Checkout -> Click on continue shopping from checkout/cart. Evid: 120.
 * Event description: Click on continue shopping from checkout/cart.

 * additionalFeesPrice - Type: numeric. Desc: number of all additional fees in the order
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * origin - Type: string. Desc: from cart/checkout page
 * @param {clickOnContinueShoppingFromCartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnContinueShoppingFromCart = function (params) {
    return { evid: 120, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} editorChangeCartIconSfeParams
* @property {string} appName - app_name
* @property {string} type - icon type
**/
/**
 * Name: Editor-> change cart icon SFE. Evid: 820.
 * Event description: select a cart icon in the mini cart settings.

 * appName - Type: string. Desc: app_name
 *
 * type - Type: string. Desc: icon type
 * @param {editorChangeCartIconSfeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorChangeCartIconSfe = function (params) {
    return { evid: 820, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} cartCartIconLoadedParams
* @property {string} appName - app_name
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} ecomId - ecom_id
* @property {boolean} isMobileFriendly - true if mobile friendly, false otherwise
* @property {string} navigationClick - mini cart / cart page
**/
/**
 * Name: Cart -> Cart Icon Loaded. Evid: 546.
 * Event description: cart icon loaded.

 * appName - Type: string. Desc: app_name
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isMobileFriendly - Type: bool. Desc: true if mobile friendly, false otherwise
 *
 * navigationClick - Type: string. Desc: mini cart / cart page
 * @param {cartCartIconLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartCartIconLoaded = function (params) {
    return { evid: 546, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} cartShowMerchantShippingPopupParams
* @property {string} appName - app_name
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} ecomId - ecom_id
* @property {string} mode - mode
* @property {string} origin - where the modal pops up (cart / product page...)
* @property {string} type - merchant pop-up / buyer pop-up
**/
/**
 * Name: Cart -> Show merchant shipping popup. Evid: 173.
 * Event description: Show shipping popup - no shipping rule for destination.

 * appName - Type: string. Desc: app_name
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * mode - Type: string. Desc: mode
 *
 * origin - Type: string. Desc: where the modal pops up (cart / product page...)
 *
 * type - Type: string. Desc: merchant pop-up / buyer pop-up
 * @param {cartShowMerchantShippingPopupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartShowMerchantShippingPopup = function (params) {
    return { evid: 173, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickPlaceOrderParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order. Not exist in OOI checkout
* @property {string} appName - app_name
* @property {string} buyerLanguage - buyer Language. Not exist in OOI checkout
* @property {GUID} cartId - cart_id
* @property {string} cartType - null
* @property {string} catalogAppId - catalog_app_id
* @property {string} channelType - what is the channel type
* @property {GUID} checkoutId - checkout_id
* @property {string} checkoutType - in viewer / out of viewer. Not exist in OOI checkout
* @property {string} contactId - Buyer's contact ID. taken from: Checkout.Chekout object.buyerInfo.contactId
* @property {string} couponCode - coupon_code. Not exist in OOI checkout
* @property {boolean} customFieldMandatory - true - if custom field was mandatory on checkout
* @property {string} customFieldsTitle - title of custom field (can be a list if there is more than one field
* @property {number} dintinctNumItems - count distinct item_id. Not exist in OOI checkout
* @property {string} distinctNumItemsPerCatalog - Json - sum of total count distinct item_id per catalog - example: {“stores”: 2, “bookings”: 3}. Not exist in OOI checkout
* @property {GUID} ecomId - ecom_id
* @property {string} first_stage - first stage open in checkout page
* @property {string} flowType - 'quick flow' / 'full flow'. For OOI Checkout- fastFlow = 'fast flow', visitorPickupFlow = 'visitor pickup flow', memberPickupFlow = 'member pickup flow', visitorShippingFlow = 'visitor shipping flow', memberShippingFlow = 'member shipping flow', nonShippableFlow = 'non shippable flow', unrecognizedFlow = 'unrecognized Flow',
* @property {string} giftCardCode - Not exist in OOI checkout
* @property {string} giftCardId - gift_card_id. Not exist in OOI checkout
* @property {boolean} hasCustomField - Not exist in OOI checkout
* @property {boolean} hasPaymentMethod - true / false. Not exist in OOI checkout
* @property {boolean} isBuyNowPayLaterOption - is buy now pay later option exist. Not exist in OOI checkout
* @property {boolean} isBuyerNote - does a buyes note exist. Not exist in OOI checkout
* @property {boolean} isCalculationErrors - does calculation errors exist. Not exist in OOI checkout
* @property {boolean} isCouponPriceSummary - does coupon exist in price summary. Not exist in OOI checkout
* @property {boolean} isDiscountPriceSummary - does discount (any kind of discount)  exist in price summary. Not exist in OOI checkout
* @property {boolean} isDiscountRulePriceSummary - does discount rule exist in price summary. Not exist in OOI checkout
* @property {boolean} isGiftCard - does gift card is available in the checkout
* @property {boolean} is_member - null
* @property {boolean} isOwner - true if visitor is the site owner
* @property {boolean} isPolicy - has policies in checkout
* @property {boolean} isPremium - Not exist in OOI checkout
* @property {boolean} is_promo_code - is promo code (coupon) option visible in the cart & checkout
* @property {boolean} isShippingPriceSummary - does shipping exist in price summary. Not exist in OOI checkout
* @property {boolean} isTaxPriceSummary - does tax exist in price summary. Not exist in OOI checkout
* @property {boolean} is_with_ewallet_payment - does the site has an ewallet payment connected
* @property {boolean} is_with_offline_payment - does the site has an offline payment connected
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} itemsQuantity - sum of total items quantity. Not exist in OOI checkout
* @property {string} itemsQuantityPerCatalog - Json - sum of total items quantity per catalog - example: {“stores”: 9, “bookings”: 7}. Not exist in OOI checkout
* @property {string} numLineItemsPerCatalog - Json - number of line items per catalog - example: {“stores”: 3, “bookings”: 4}
* @property {number} numOfLineItems - number of line items (# of products) in cart included the product just added
* @property {number} num_of_paymet_providers - How many payment providers does the site has connected. Not exist in OOI checkout
* @property {number} num_of_shipping - number of shipping choices presented to the visitor
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {string} origin - the component / page that the visitor came from to the checkout, like product page, cart page, etc.
* @property {string} originType - the type of flow that lead to the checkout, like buy now, paypal, etc.
* @property {GUID} owner_id - null
* @property {string} paymentMethod - authorize-net/Stripe
* @property {string} paymet_providers - array of payment providers connected to the store site
* @property {boolean} savedAddress - true if the member has saved address
* @property {string} selectedCarrierServiceOption - Take from: Checkout.Chekout object.Shipping Info.selectedCarrierServiceOption
* @property {string} selectedDeliveryOption - what was the selected delivery option
* @property {string} shippingCity - buyer city. Take from: Checkout.Chekout object.Shipping Info. shipping destenation.address.city
* @property {string} shippingCountry - buyer country code. Take from: Checkout.Chekout object.Shipping Info. shipping destenation.address.country
* @property {string} shippingMethodType - what was the selected shipping option (shipping /store pickup / none)
* @property {string} siteLanguage - site Language
* @property {GUID} siteMemberId - null
* @property {string} validationMessage - JSON with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
* @property {string} validationSpi - jason with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
**/
/**
 * Name: Checkout -> Click Place order. Evid: 168.
 * Event description: click on place order (client event). since june 2019 also from OneApp (leads to cashier screen to choose payment method and pay).

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order. Not exist in OOI checkout
 *
 * appName - Type: string. Desc: app_name
 *
 * buyerLanguage - Type: string. Desc: buyer Language. Not exist in OOI checkout
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string.
 *
 * catalogAppId - Type: string. Desc: catalog_app_id
 *
 * channelType - Type: string. Desc: what is the channel type
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * checkoutType - Type: string. Desc: in viewer / out of viewer. Not exist in OOI checkout
 *
 * contactId - Type: string. Desc: Buyer's contact ID. taken from: Checkout.Chekout object.buyerInfo.contactId
 *
 * couponCode - Type: string. Desc: coupon_code. Not exist in OOI checkout
 *
 * customFieldMandatory - Type: bool. Desc: true - if custom field was mandatory on checkout
 *
 * customFieldsTitle - Type: string. Desc: title of custom field (can be a list if there is more than one field
 *
 * dintinctNumItems - Type: numeric. Desc: count distinct item_id. Not exist in OOI checkout
 *
 * distinctNumItemsPerCatalog - Type: string. Desc: Json - sum of total count distinct item_id per catalog - example: {“stores”: 2, “bookings”: 3}. Not exist in OOI checkout
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * first_stage - Type: string. Desc: first stage open in checkout page
 *
 * flowType - Type: string. Desc: 'quick flow' / 'full flow'. For OOI Checkout- fastFlow = 'fast flow', visitorPickupFlow = 'visitor pickup flow', memberPickupFlow = 'member pickup flow', visitorShippingFlow = 'visitor shipping flow', memberShippingFlow = 'member shipping flow', nonShippableFlow = 'non shippable flow', unrecognizedFlow = 'unrecognized Flow',
 *
 * giftCardCode - Type: string. Desc: Not exist in OOI checkout
 *
 * giftCardId - Type: string. Desc: gift_card_id. Not exist in OOI checkout
 *
 * hasCustomField - Type: bool. Desc: Not exist in OOI checkout
 *
 * hasPaymentMethod - Type: bool. Desc: true / false. Not exist in OOI checkout
 *
 * isBuyNowPayLaterOption - Type: bool. Desc: is buy now pay later option exist. Not exist in OOI checkout
 *
 * isBuyerNote - Type: bool. Desc: does a buyes note exist. Not exist in OOI checkout
 *
 * isCalculationErrors - Type: bool. Desc: does calculation errors exist. Not exist in OOI checkout
 *
 * isCouponPriceSummary - Type: bool. Desc: does coupon exist in price summary. Not exist in OOI checkout
 *
 * isDiscountPriceSummary - Type: bool. Desc: does discount (any kind of discount)  exist in price summary. Not exist in OOI checkout
 *
 * isDiscountRulePriceSummary - Type: bool. Desc: does discount rule exist in price summary. Not exist in OOI checkout
 *
 * isGiftCard - Type: bool. Desc: does gift card is available in the checkout
 *
 * is_member - Type: bool.
 *
 * isOwner - Type: bool. Desc: true if visitor is the site owner
 *
 * isPolicy - Type: bool. Desc: has policies in checkout
 *
 * isPremium - Type: bool. Desc: Not exist in OOI checkout
 *
 * is_promo_code - Type: bool. Desc: is promo code (coupon) option visible in the cart & checkout
 *
 * isShippingPriceSummary - Type: bool. Desc: does shipping exist in price summary. Not exist in OOI checkout
 *
 * isTaxPriceSummary - Type: bool. Desc: does tax exist in price summary. Not exist in OOI checkout
 *
 * is_with_ewallet_payment - Type: bool. Desc: does the site has an ewallet payment connected
 *
 * is_with_offline_payment - Type: bool. Desc: does the site has an offline payment connected
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * itemsQuantity - Type: numeric. Desc: sum of total items quantity. Not exist in OOI checkout
 *
 * itemsQuantityPerCatalog - Type: string. Desc: Json - sum of total items quantity per catalog - example: {“stores”: 9, “bookings”: 7}. Not exist in OOI checkout
 *
 * numLineItemsPerCatalog - Type: string. Desc: Json - number of line items per catalog - example: {“stores”: 3, “bookings”: 4}
 *
 * numOfLineItems - Type: numeric. Desc: number of line items (# of products) in cart included the product just added
 *
 * num_of_paymet_providers - Type: numeric. Desc: How many payment providers does the site has connected. Not exist in OOI checkout
 *
 * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * origin - Type: string. Desc: the component / page that the visitor came from to the checkout, like product page, cart page, etc.
 *
 * originType - Type: string. Desc: the type of flow that lead to the checkout, like buy now, paypal, etc.
 *
 * owner_id - Type: guid.
 *
 * paymentMethod - Type: string. Desc: authorize-net/Stripe
 *
 * paymet_providers - Type: string. Desc: array of payment providers connected to the store site
 *
 * savedAddress - Type: bool. Desc: true if the member has saved address
 *
 * selectedCarrierServiceOption - Type: string. Desc: Take from: Checkout.Chekout object.Shipping Info.selectedCarrierServiceOption
 *
 * selectedDeliveryOption - Type: string. Desc: what was the selected delivery option
 *
 * shippingCity - Type: string. Desc: buyer city. Take from: Checkout.Chekout object.Shipping Info. shipping destenation.address.city
 *
 * shippingCountry - Type: string. Desc: buyer country code. Take from: Checkout.Chekout object.Shipping Info. shipping destenation.address.country
 *
 * shippingMethodType - Type: string. Desc: what was the selected shipping option (shipping /store pickup / none)
 *
 * siteLanguage - Type: string. Desc: site Language
 *
 * siteMemberId - Type: guid.
 *
 * validationMessage - Type: string. Desc: JSON with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
 *
 * validationSpi - Type: string. Desc: jason with the validation that appear in the checkout while loaded. {type - warning/error, is_line_item - true/false, message - what the uou saw}
 * @param {clickPlaceOrderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickPlaceOrder = function (params) {
    return { evid: 168, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} giftCardCheckoutClickOnCheckboxParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - null
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {boolean} isMember - true if visitor is member
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {string} value - behavior type. in the old checkout - unchecked/check. in the new checkout - null (no checkbox action)
**/
/**
 * Name: gift card checkout -> click on checkbox / Click on "Redeem a Gift Card". Evid: 527.
 * Event description: in the old checkout - when a visitor checks / unchecks the Gift Card checkbox in the Payment stage. in the new checkout (out of Iframe) -  when a visitor clicks on "Redeem a gift card" (first step of applying gift card). Notice - the old flow have both the opinion to check/uncheck gift card. the new only have click to open the flow (without closing)..

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string.
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isMember - Type: bool. Desc: true if visitor is member
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * value - Type: string. Desc: behavior type. in the old checkout - unchecked/check. in the new checkout - null (no checkbox action)
 * @param {giftCardCheckoutClickOnCheckboxParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var giftCardCheckoutClickOnCheckbox = function (params) {
    return { evid: 527, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutMemberMemberAddressUpdatedParams
* @property {GUID} addressId - address_id
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical) etc
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {boolean} isDefault - was set to default
* @property {boolean} isSetAsDefaultChecked - true - was checked as default (new default or from last edit)
* @property {string} stage - in which stage the visitor change/edit - contact-details or billing
**/
/**
 * Name: Checkout Member ->  Member Address Updated. Evid: 825.
 * Event description: when a member updates (edits) an existing address.

 * addressId - Type: guid. Desc: address_id
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical) etc
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isDefault - Type: bool. Desc: was set to default
 *
 * isSetAsDefaultChecked - Type: bool. Desc: true - was checked as default (new default or from last edit)
 *
 * stage - Type: string. Desc: in which stage the visitor change/edit - contact-details or billing
 * @param {checkoutMemberMemberAddressUpdatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutMemberMemberAddressUpdated = function (params) {
    return { evid: 825, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} couponAppliedParams
* @property {string} appName - null
* @property {GUID} cartId - null
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {string} name - null
* @property {string} couponCode - null
* @property {string} couponId - null
* @property {GUID} ecomId - ecom_id
* @property {boolean} isMember - null
* @property {boolean} isOwner - null
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {string} origin - null
* @property {GUID} owner_id - null
* @property {number} total_long - null
* @property {string} type - null
**/
/**
 * Name: Checkout -> Coupon applied. Evid: 119.


 * appName - Type: string.
 *
 * cartId - Type: guid.
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * name - Type: string.
 *
 * couponCode - Type: string.
 *
 * couponId - Type: string.
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isMember - Type: bool.
 *
 * isOwner - Type: bool.
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * origin - Type: string.
 *
 * owner_id - Type: guid.
 *
 * total_long - Type: numeric.
 *
 * type - Type: string.
 * @param {couponAppliedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var couponApplied = function (params) {
    return { evid: 119, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickOnReturnToCheckoutInLogoutModalParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - null
* @property {GUID} cartId - null
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} flowType - 'quick flow' / 'full flow'
* @property {boolean} is_member - true if the visitor signed in as a member, false otherwise
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {boolean} savedAddress - true if the member has saved address
* @property {GUID} siteMemberId - member id
**/
/**
 * Name: Checkout -> Click on return to checkout in logout modal. Evid: 603.
 * Event description: buyer clicks on "return to checkout" or X in logout modal in checkout to close it.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string.
 *
 * cartId - Type: guid.
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * flowType - Type: string. Desc: 'quick flow' / 'full flow'
 *
 * is_member - Type: bool. Desc: true if the visitor signed in as a member, false otherwise
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * savedAddress - Type: bool. Desc: true if the member has saved address
 *
 * siteMemberId - Type: guid. Desc: member id
 * @param {clickOnReturnToCheckoutInLogoutModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnReturnToCheckoutInLogoutModal = function (params) {
    return { evid: 603, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} deliveryMethodSetParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {number} optionscount - number of payment options
* @property {GUID} ecomId - ecom_id
* @property {number} selectedoptionindex - index of selected option
* @property {boolean} isOwner - true if visitor is the site owner
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {string} methodType - pickup/non-pickup
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {string} orig_shipping_method - current shipping method in cart page (free shipping/ Flat rate/ rate by weight/ etc...)
* @property {GUID} owner_id - uuid of site owner
* @property {string} shippingRuleOptions - all the shipping types presented in the modal
* @property {string} selectedoptiontype - type of option selected
**/
/**
 * Name: Checkout -> Delivery method set. Evid: 163.
 * Event description: Click on continue to payment (on web) since June 2019 also sent from OneApp (leads to "Review Order" (placeOrder) screen).

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * optionscount - Type: numeric. Desc: number of payment options
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * selectedoptionindex - Type: numeric. Desc: index of selected option
 *
 * isOwner - Type: bool. Desc: true if visitor is the site owner
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * methodType - Type: string. Desc: pickup/non-pickup
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * orig_shipping_method - Type: string. Desc: current shipping method in cart page (free shipping/ Flat rate/ rate by weight/ etc...)
 *
 * owner_id - Type: guid. Desc: uuid of site owner
 *
 * shippingRuleOptions - Type: string. Desc: all the shipping types presented in the modal
 *
 * selectedoptiontype - Type: string. Desc: type of option selected
 * @param {deliveryMethodSetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var deliveryMethodSet = function (params) {
    return { evid: 163, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickApplyCouponParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in cart/order
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {string} couponCode - coupon_code
* @property {GUID} ecomId - ecom_id
* @property {boolean} isMember - true if visitor is member
* @property {boolean} isOwner - true if visitor is the site owner
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the cart/order
* @property {string} origin - shopping cart / checkout
* @property {GUID} owner_id - uuid of site owner
**/
/**
 * Name: Checkout > Click 'Apply' Coupon. Evid: 112.
 * Event description: after entering promo code click on Apply. since june 2019 can be sent also from OA StoreFront.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in cart/order
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * couponCode - Type: string. Desc: coupon_code
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isMember - Type: bool. Desc: true if visitor is member
 *
 * isOwner - Type: bool. Desc: true if visitor is the site owner
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the cart/order
 *
 * origin - Type: string. Desc: shopping cart / checkout
 *
 * owner_id - Type: guid. Desc: uuid of site owner
 * @param {clickApplyCouponParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickApplyCoupon = function (params) {
    return { evid: 112, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} giftCardCheckoutCodeAppliedParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - null
* @property {GUID} cartId - cart id
* @property {string} catalogAppId - List of distinct checkout.lineItems.itemType
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} giftCardId - gift_card_id
* @property {boolean} isCartPaidOnlyWithGiftCard - True if payments options are hidden due to gift card fully cover the payment (with coupon or without)
* @property {boolean} isMember - true if visitor is member
* @property {string} itemType - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
**/
/**
 * Name: gift card checkout -> code applied. Evid: 535.
 * Event description: when Gift Card Code was successfully applied in Payment stage of Checkout.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string.
 *
 * cartId - Type: guid. Desc: cart id
 *
 * catalogAppId - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * giftCardId - Type: string. Desc: gift_card_id
 *
 * isCartPaidOnlyWithGiftCard - Type: bool. Desc: True if payments options are hidden due to gift card fully cover the payment (with coupon or without)
 *
 * isMember - Type: bool. Desc: true if visitor is member
 *
 * itemType - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 * @param {giftCardCheckoutCodeAppliedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var giftCardCheckoutCodeApplied = function (params) {
    return { evid: 535, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} bisRequestIsAlreadyCreatedErrorParams
* @property {GUID} appId - the app Id of the catalog
* @property {string} catalogAppId - catalog app id
* @property {GUID} catalogInstanceId - In case of stores (store_id)
* @property {string} catalogItemId - The guid of the requested item (product_guid / service_id..)
* @property {string} options - map of strings of the options chosen in the requested item
**/
/**
 * Name: BIS - Request is already created error. Evid: 27.
 * Event description: When a user clicks the submit button after a request is already made. and he gets an error for it.

 * appId - Type: guid. Desc: the app Id of the catalog
 *
 * catalogAppId - Type: string. Desc: catalog app id
 *
 * catalogInstanceId - Type: guid. Desc: In case of stores (store_id)
 *
 * catalogItemId - Type: string. Desc: The guid of the requested item (product_guid / service_id..)
 *
 * options - Type: string. Desc: map of strings of the options chosen in the requested item
 * @param {bisRequestIsAlreadyCreatedErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bisRequestIsAlreadyCreatedError = function (params) {
    return { evid: 27, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} removedProductFromCartSfParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in cart
* @property {string} appName - app_name
* @property {GUID} cartId - cart id
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} checkoutId - checkout_id
* @property {number} itemsCount - origin
* @property {GUID} ecomId - ecom_id
* @property {number} numberOfAdditionalFees - number of all additional fees in the cart
* @property {string} origin - number of items in the cart
* @property {GUID} owner_id - id of site's owner. since june 2019
* @property {string} productId - product_id
* @property {string} productType - digital / physical
**/
/**
 * Name: Cart -> Removed product from cart SF. Evid: 115.
 * Event description: Removed product from cart SF. since june 2019 also for OneApp StoreFront (member view).

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in cart
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * itemsCount - Type: numeric. Desc: origin
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the cart
 *
 * origin - Type: string. Desc: number of items in the cart
 *
 * owner_id - Type: guid. Desc: id of site's owner. since june 2019
 *
 * productId - Type: string. Desc: product_id
 *
 * productType - Type: string. Desc: digital / physical
 * @param {removedProductFromCartSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var removedProductFromCartSf = function (params) {
    return { evid: 115, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutClickOnCallToActionInMerchantPopUpSfParams
* @property {string} appName - app_name
* @property {GUID} ecomId - ecom_id
* @property {string} notificationType - payments/upgrade/shipping
* @property {string} type - merchant pop-up / buyer pop-up
**/
/**
 * Name: Checkout -> click on call to action in merchant pop-up SF. Evid: 169.
 * Event description: click on call to action (upgrade / set payment) in merchant pop-up.

 * appName - Type: string. Desc: app_name
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * notificationType - Type: string. Desc: payments/upgrade/shipping
 *
 * type - Type: string. Desc: merchant pop-up / buyer pop-up
 * @param {checkoutClickOnCallToActionInMerchantPopUpSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutClickOnCallToActionInMerchantPopUpSf = function (params) {
    return { evid: 169, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} ordersClickInOrderHistoryPageSfParams
* @property {string} appName - app_name
* @property {string} catalogAppId - list of all catalog app ids
* @property {string} click_type - go_shopping / track_order / download / view_invoice
* @property {string} contact_id - contact_id
* @property {string} orderId - orderId
* @property {string} origin - order_history_page / order_details_page
* @property {string} productId - only for click on "Track item" in order details page
* @property {GUID} site_member_id - member id
**/
/**
 * Name: Orders -> click in order_history page  SF. Evid: 129.
 * Event description: UoU clicks that are coming from the order_history page.

 * appName - Type: string. Desc: app_name
 *
 * catalogAppId - Type: string. Desc: list of all catalog app ids
 *
 * click_type - Type: string. Desc: go_shopping / track_order / download / view_invoice
 *
 * contact_id - Type: string. Desc: contact_id
 *
 * orderId - Type: string. Desc: orderId
 *
 * origin - Type: string. Desc: order_history_page / order_details_page
 *
 * productId - Type: string. Desc: only for click on "Track item" in order details page
 *
 * site_member_id - Type: guid. Desc: member id
 * @param {ordersClickInOrderHistoryPageSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ordersClickInOrderHistoryPageSf = function (params) {
    return { evid: 129, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} deleteNoteToSellerSfParams
* @property {string} appName - app_name
* @property {GUID} cartId - cart id
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
**/
/**
 * Name: Cart -> Delete note to seller SF. Evid: 123.
 * Event description: buyer clicks on 'delete note to seller' in cart page.

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 * @param {deleteNoteToSellerSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var deleteNoteToSellerSf = function (params) {
    return { evid: 123, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickOnShippingDestinationInCartPageSfParams
* @property {string} appName - app_name
* @property {GUID} cartId - null
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} checkoutId - null
* @property {GUID} ecomId - ecom_id
* @property {string} shippingDestinationCountry - null
* @property {string} shippingDestinationState - shipping destination state
**/
/**
 * Name: Cart -> Click on shipping destination in page SF. Evid: 223.


 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid.
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * checkoutId - Type: guid.
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * shippingDestinationCountry - Type: string.
 *
 * shippingDestinationState - Type: string. Desc: shipping destination state
 * @param {clickOnShippingDestinationInCartPageSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnShippingDestinationInCartPageSf = function (params) {
    return { evid: 223, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} editorChangeStyleColorSfeParams
* @property {string} appName - app_name
* @property {string} component_id - grid gallery, slider galeery, product page,CurrencyConverter, AvalaraTax
* @property {string} editorMode - mobile / desktop
* @property {string} element - product image, name&price&sku, product options&quantity, button, info sections, social media
* @property {string} parameter - facebook,tweeter, image scaling, navigation position
* @property {string} value - behavior type
**/
/**
 * Name: Editor-> change style & color SFE. Evid: 812.
 * Event description: upon changing a store style or color.

 * appName - Type: string. Desc: app_name
 *
 * component_id - Type: string. Desc: grid gallery, slider galeery, product page,CurrencyConverter, AvalaraTax
 *
 * editorMode - Type: string. Desc: mobile / desktop
 *
 * element - Type: string. Desc: product image, name&price&sku, product options&quantity, button, info sections, social media
 *
 * parameter - Type: string. Desc: facebook,tweeter, image scaling, navigation position
 *
 * value - Type: string. Desc: behavior type
 * @param {editorChangeStyleColorSfeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorChangeStyleColorSfe = function (params) {
    return { evid: 812, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} membersClickChangeInCheckoutStagesParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {string} stage - which stage in the wishlist installation process
**/
/**
 * Name: members -> click 'change' in checkout stages. Evid: 46.
 * Event description: click to 'change' autofill info in the checkout process.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * stage - Type: string. Desc: which stage in the wishlist installation process
 * @param {membersClickChangeInCheckoutStagesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var membersClickChangeInCheckoutStages = function (params) {
    return { evid: 46, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickOnCheckoutWithEWalletParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in cart
* @property {string} appName - app_name
* @property {GUID} cartId - null
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} checkoutId - checkout_id
* @property {number} itemsCount - Numbers of items in cart
* @property {GUID} ecomId - ecom_id
* @property {boolean} is_with_ewallet_payment - does the store has an ewallet payment connected (and displaying in cart)
* @property {boolean} is_with_offline_payment - does the store has an offline payment connected
* @property {number} num_of_paymet_providers - How many payment providers does the store has connected
* @property {number} num_of_shipping - number of shipping choices presented to the visitor
* @property {number} numberOfAdditionalFees - number of all additional fees in the cart
* @property {string} orig_shipping_method - current shipping method in cart page (free shipping/ Flat rate/ rate by weight/ etc...)
* @property {string} origin - origin
* @property {string} paymet_providers - array of payment providers connected to the store
* @property {string} productsList - json containing all product guids for products in the cart
* @property {string} shippingMethodType - shipping /store pickup / none
* @property {string} type - button / tooltip / banner
**/
/**
 * Name: Cart -> Click on checkout with e-wallet. Evid: 113.
 * Event description: buyer clicks on checkout with e-wallwt in cart page.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in cart
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid.
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * itemsCount - Type: numeric. Desc: Numbers of items in cart
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * is_with_ewallet_payment - Type: bool. Desc: does the store has an ewallet payment connected (and displaying in cart)
 *
 * is_with_offline_payment - Type: bool. Desc: does the store has an offline payment connected
 *
 * num_of_paymet_providers - Type: numeric. Desc: How many payment providers does the store has connected
 *
 * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the cart
 *
 * orig_shipping_method - Type: string. Desc: current shipping method in cart page (free shipping/ Flat rate/ rate by weight/ etc...)
 *
 * origin - Type: string. Desc: origin
 *
 * paymet_providers - Type: string. Desc: array of payment providers connected to the store
 *
 * productsList - Type: string. Desc: json containing all product guids for products in the cart
 *
 * shippingMethodType - Type: string. Desc: shipping /store pickup / none
 *
 * type - Type: string. Desc: button / tooltip / banner
 * @param {clickOnCheckoutWithEWalletParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnCheckoutWithEWallet = function (params) {
    return { evid: 113, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutErrorTrackingForDevelopersParams
* @property {string} data - data
* @property {string} error - error
**/
/**
 * Name: Checkout -> Error tracking for developers. Evid: 713.
 * Event description: Debug for developers.

 * data - Type: string. Desc: data
 *
 * error - Type: string. Desc: error
 * @param {checkoutErrorTrackingForDevelopersParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutErrorTrackingForDevelopers = function (params) {
    return { evid: 713, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} giftCardCheckoutRemoveCodeParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - null
* @property {GUID} cartId - null
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} giftCardId - null
* @property {boolean} isMember - true if visitor is member
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
**/
/**
 * Name: gift card checkout -> remove Code. Evid: 536.
 * Event description: when visitor clicks "remove" after applying Gift Card Codein Payment stage of Checkout.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string.
 *
 * cartId - Type: guid.
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * giftCardId - Type: string.
 *
 * isMember - Type: bool. Desc: true if visitor is member
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 * @param {giftCardCheckoutRemoveCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var giftCardCheckoutRemoveCode = function (params) {
    return { evid: 536, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutClickOnContinueInCheckoutProcessParams
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {boolean} isOwner - true if visitor is the site owner
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {GUID} owner_id - uuid of site owner
* @property {string} previousStage - the closed stage - payment / shippingDetails / deliveryMethod / payment-method / pickupDetails / shipping-method / customerDetails
* @property {string} stage - which stage in the wishlist installation process
**/
/**
 * Name: Checkout -> click on ‘continue’ in checkout process. Evid: 29.
 * Event description: When the user clicks on “continue”  on a specific stage in checkout process.

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isOwner - Type: bool. Desc: true if visitor is the site owner
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * owner_id - Type: guid. Desc: uuid of site owner
 *
 * previousStage - Type: string. Desc: the closed stage - payment / shippingDetails / deliveryMethod / payment-method / pickupDetails / shipping-method / customerDetails
 *
 * stage - Type: string. Desc: which stage in the wishlist installation process
 * @param {checkoutClickOnContinueInCheckoutProcessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutClickOnContinueInCheckoutProcess = function (params) {
    return { evid: 29, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutClickOnCheckoutPoliciesParams
* @property {string} appName - app_name (added from 21/03/23)
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} linkLocation - the location of the link. The options are: footer / form
* @property {string} policyType - on which policy the user clicked. The options: terms and conditions / privacy policy / return policy / digital item policy / contact us / custom policy
**/
/**
 * Name: Checkout -> click on checkout policies. Evid: 712.
 * Event description: When the user clicks on one of the checkout policies.

 * appName - Type: string. Desc: app_name (added from 21/03/23)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * linkLocation - Type: string. Desc: the location of the link. The options are: footer / form
 *
 * policyType - Type: string. Desc: on which policy the user clicked. The options: terms and conditions / privacy policy / return policy / digital item policy / contact us / custom policy
 * @param {checkoutClickOnCheckoutPoliciesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutClickOnCheckoutPolicies = function (params) {
    return { evid: 712, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} editorClickOnChangeLinkInSettingsSfeParams
* @property {string} appName - app_name
* @property {string} component_id - null
* @property {string} element - product image, name&price&sku, product options&quantity, button, info sections, social media,continue shopping / empty state / back to store..
* @property {string} link - current navigation link
**/
/**
 * Name: Editor-> Click on change link in settings SFE. Evid: 196.
 * Event description: when the user click on the change link in the settings of the cart or the thank you page / my orders...

 * appName - Type: string. Desc: app_name
 *
 * component_id - Type: string.
 *
 * element - Type: string. Desc: product image, name&price&sku, product options&quantity, button, info sections, social media,continue shopping / empty state / back to store..
 *
 * link - Type: string. Desc: current navigation link
 * @param {editorClickOnChangeLinkInSettingsSfeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorClickOnChangeLinkInSettingsSfe = function (params) {
    return { evid: 196, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} editorChangeMiniCartBehaviorSfeParams
* @property {string} appName - app_name
* @property {string} parameter - parameter
* @property {string} value - behavior type (openMiniCart/openCartPage)
**/
/**
 * Name: Editor-> change mini cart behavior SFE. Evid: 822.
 * Event description: select a behavior for click on the mini cart in mini cart settings.

 * appName - Type: string. Desc: app_name
 *
 * parameter - Type: string. Desc: parameter
 *
 * value - Type: string. Desc: behavior type (openMiniCart/openCartPage)
 * @param {editorChangeMiniCartBehaviorSfeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorChangeMiniCartBehaviorSfe = function (params) {
    return { evid: 822, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickToOpenStoreManagerSfeParams
* @property {string} appName - app_name
* @property {string} component_id - grid gallery, slider galeery, product page
* @property {string} targetPage - product list / product / dashboard / ....
**/
/**
 * Name: click to open store manager SFE. Evid: 814.
 * Event description: clicking 're-order products in collection' (store manager is opened in collection page).

 * appName - Type: string. Desc: app_name
 *
 * component_id - Type: string. Desc: grid gallery, slider galeery, product page
 *
 * targetPage - Type: string. Desc: product list / product / dashboard / ....
 * @param {clickToOpenStoreManagerSfeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickToOpenStoreManagerSfe = function (params) {
    return { evid: 814, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickToViewCartPageParams
* @property {string} appName - null
* @property {GUID} cartId - null
* @property {string} cartType - null
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} checkoutId - checkout_id
* @property {number} itemsCount - null
* @property {GUID} ecomId - ecom_id
* @property {boolean} isNavigateCart - null
* @property {string} origin - null
* @property {GUID} owner_id - null
* @property {string} viewMode - null
**/
/**
 * Name: Cart -> Click to view cart page. Evid: 130.
 * Event description: click to view cart page. since june 2019 also for OneApp Store front.

 * appName - Type: string.
 *
 * cartId - Type: guid.
 *
 * cartType - Type: string.
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * itemsCount - Type: numeric.
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isNavigateCart - Type: bool.
 *
 * origin - Type: string.
 *
 * owner_id - Type: guid.
 *
 * viewMode - Type: string.
 * @param {clickToViewCartPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickToViewCartPage = function (params) {
    return { evid: 130, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutErrorWhenApplyingAGiftCardParams
* @property {string} appName - app name
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {string} errorCode - error code
* @property {GUID} ecomId - ecom_id
* @property {boolean} isMember - is_member
* @property {string} itemType - List of distinct checkout.lineItems.itemType
**/
/**
 * Name: Checkout -> Error when applying a Gift Card. Evid: 717.
 * Event description: when a uou has an error while applying gift card in the checkout.
(Only for the OOO checkout, for the old checkout data - check 130:24).

 * appName - Type: string. Desc: app name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * errorCode - Type: string. Desc: error code
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isMember - Type: bool. Desc: is_member
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 * @param {checkoutErrorWhenApplyingAGiftCardParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutErrorWhenApplyingAGiftCard = function (params) {
    return { evid: 717, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutLoadingCheckoutPageFailForDevParams

**/
/**
 * Name: Checkout -> Loading checkout page fail (for dev). Evid: 719.
 * Event description: when the checkout is corrupted.


 * @param {checkoutLoadingCheckoutPageFailForDevParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutLoadingCheckoutPageFailForDev = function (params) {
    return { evid: 719, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickToViewProductFromCartPageOaParams
* @property {string} cartId - cartId
* @property {string} catalogAppId - Stores/bookings App id
* @property {string} catalogItemId - productId in case of Stores, Bookingid in case od bookings
* @property {GUID} ecomId - ecom_id
* @property {boolean} hasOptions - has_options
* @property {string} itemType - productType in case of Stores
* @property {string} origin - catalog_OA / cart_OA (from OneApp Stores front) / quick-view
**/
/**
 * Name: Cart -> Click to View product (from cart page)  OA. Evid: 706.
 * Event description: Click to View product (from cart page)  OA.

 * cartId - Type: string. Desc: cartId
 *
 * catalogAppId - Type: string. Desc: Stores/bookings App id
 *
 * catalogItemId - Type: string. Desc: productId in case of Stores, Bookingid in case od bookings
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * hasOptions - Type: bool. Desc: has_options
 *
 * itemType - Type: string. Desc: productType in case of Stores
 *
 * origin - Type: string. Desc: catalog_OA / cart_OA (from OneApp Stores front) / quick-view
 * @param {clickToViewProductFromCartPageOaParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickToViewProductFromCartPageOa = function (params) {
    return { evid: 706, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickOnMyOrdersInThankYouPageOaStoreFrontParams
* @property {string} cartId - cartId
* @property {string} catalogAppId - Stores/bookings App id
* @property {string} orderId - orderId
**/
/**
 * Name: Click on "My Orders" in Thank you page OA StoreFront. Evid: 187.
 * Event description: Click on "My Orders" in Thank you page OA StoreFront.

 * cartId - Type: string. Desc: cartId
 *
 * catalogAppId - Type: string. Desc: Stores/bookings App id
 *
 * orderId - Type: string. Desc: orderId
 * @param {clickOnMyOrdersInThankYouPageOaStoreFrontParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnMyOrdersInThankYouPageOaStoreFront = function (params) {
    return { evid: 187, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} bisClickOnNotifyMeButtonToOpenModalParams
* @property {GUID} appId - the app Id of the catalog
* @property {string} catalogAppId - catalog app id
* @property {GUID} catalogInstanceId - In case of stores (store_id)
* @property {string} catalogItemId - The guid of the requested item (product_guid / service_id..)
* @property {boolean} eligible - true (all options selected/no options ->eligible  to open modal) false (not all the options are selected - not eligible - shows error)
* @property {string} option - map of strings of the options chosen in the requested item
* @property {string} origin - product page / quick view / gallery
**/
/**
 * Name: BIS - Click on notify me button to open modal. Evid: 25.
 * Event description: When a user clicks on notify me button to open modal.
if eligible = true, then the modal should open
if eligible = false, then the button is disabled and the user will get an error..

 * appId - Type: guid. Desc: the app Id of the catalog
 *
 * catalogAppId - Type: string. Desc: catalog app id
 *
 * catalogInstanceId - Type: guid. Desc: In case of stores (store_id)
 *
 * catalogItemId - Type: string. Desc: The guid of the requested item (product_guid / service_id..)
 *
 * eligible - Type: bool. Desc: true (all options selected/no options ->eligible  to open modal) false (not all the options are selected - not eligible - shows error)
 *
 * option - Type: string. Desc: map of strings of the options chosen in the requested item
 *
 * origin - Type: string. Desc: product page / quick view / gallery
 * @param {bisClickOnNotifyMeButtonToOpenModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bisClickOnNotifyMeButtonToOpenModal = function (params) {
    return { evid: 25, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickManageProductInCartOaStoreFrontParams
* @property {string} cartId - cartId
* @property {string} cartType - cartType
* @property {string} catalogAppId - Stores/bookings App id
* @property {string} productId - productId
* @property {string} productType - productType
**/
/**
 * Name: Click Manage Product in cart OA StoreFront. Evid: 185.
 * Event description: Click Manage Product in cart OA StoreFront.

 * cartId - Type: string. Desc: cartId
 *
 * cartType - Type: string. Desc: cartType
 *
 * catalogAppId - Type: string. Desc: Stores/bookings App id
 *
 * productId - Type: string. Desc: productId
 *
 * productType - Type: string. Desc: productType
 * @param {clickManageProductInCartOaStoreFrontParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickManageProductInCartOaStoreFront = function (params) {
    return { evid: 185, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} checkoutIntegratingFormsFailureParams
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {string} flowType - 'quick flow' / 'full flow'
* @property {string} formsTemplatesId - form_template_id
* @property {string} networkError - network_error
**/
/**
 * Name: Checkout -> integrating forms failure. Evid: 823.
 * Event description: This event sent when an error in initForms function (integrating forms to checkout) appeared..

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * flowType - Type: string. Desc: 'quick flow' / 'full flow'
 *
 * formsTemplatesId - Type: string. Desc: form_template_id
 *
 * networkError - Type: string. Desc: network_error
 * @param {checkoutIntegratingFormsFailureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var checkoutIntegratingFormsFailure = function (params) {
    return { evid: 823, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} cartSelectShippingMethodFromTheDropdownInCartPageParams
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {string} selected_shipping_method - the new shipping method that was selected from the dropdown in cart page (free shipping/ Flat rate/ rate by weight/ etc...)
**/
/**
 * Name: Cart -> Select shipping method from the dropdown in cart page. Evid: 222.
 * Event description: ***NOT IN USE*** doesnt send data also in src 10. When a visitor clicks on one of the options in the shipping method dropdown on the cart page.

 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * selected_shipping_method - Type: string. Desc: the new shipping method that was selected from the dropdown in cart page (free shipping/ Flat rate/ rate by weight/ etc...)
 * @param {cartSelectShippingMethodFromTheDropdownInCartPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartSelectShippingMethodFromTheDropdownInCartPage = function (params) {
    return { evid: 222, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} clickContinueEWalletModalSfParams
* @property {string} appName - app_name
* @property {GUID} cartId - cart id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} checkoutId - checkout_id
* @property {number} itemsCount - Numbers of items in cart
* @property {GUID} ecomId - ecom_id
* @property {number} num_of_paymet_providers - How many payment providers does the store has connected
* @property {number} num_of_shipping - number of shipping choices presented to the visitor at the first time
* @property {string} origin - origin
* @property {string} paymet_providers - array of payment providers connected to the store
* @property {string} productsList - json containing all product guids for products in the cart
* @property {string} type - add / edit
**/
/**
 * Name: Checkout -> Click Continue e-wallet Modal SF. Evid: 225.
 * Event description: When a visitor clicks on ‘Continue’ in e-wallet Modal (after the click the visitor is supposed to view the checkout)..

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * itemsCount - Type: numeric. Desc: Numbers of items in cart
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * num_of_paymet_providers - Type: numeric. Desc: How many payment providers does the store has connected
 *
 * num_of_shipping - Type: numeric. Desc: number of shipping choices presented to the visitor at the first time
 *
 * origin - Type: string. Desc: origin
 *
 * paymet_providers - Type: string. Desc: array of payment providers connected to the store
 *
 * productsList - Type: string. Desc: json containing all product guids for products in the cart
 *
 * type - Type: string. Desc: add / edit
 * @param {clickContinueEWalletModalSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickContinueEWalletModalSf = function (params) {
    return { evid: 225, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} editorResetAppSettingsSfeParams
* @property {string} appName - app_name
* @property {string} component_id - CurrencyConverter, AvalaraTax
**/
/**
 * Name: Editor-> reset app settings SFE. Evid: 819.
 * Event description: click on 'reset settings' in app settings panel.

 * appName - Type: string. Desc: app_name
 *
 * component_id - Type: string. Desc: CurrencyConverter, AvalaraTax
 * @param {editorResetAppSettingsSfeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorResetAppSettingsSfe = function (params) {
    return { evid: 819, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} logoutModalInCheckoutLoadedParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - null
* @property {GUID} cartId - cart_id
* @property {string} cartType - null
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
* @property {string} flowType - 'quick flow' / 'full flow'
* @property {boolean} is_member - null
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {boolean} savedAddress - true if the member has saved address
**/
/**
 * Name: Checkout -> logout modal in checkout loaded. Evid: 602.
 * Event description: logout modal loaded in checkout after member presses logout.

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string.
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string.
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * flowType - Type: string. Desc: 'quick flow' / 'full flow'
 *
 * is_member - Type: bool.
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * savedAddress - Type: bool. Desc: true if the member has saved address
 * @param {logoutModalInCheckoutLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var logoutModalInCheckoutLoaded = function (params) {
    return { evid: 602, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} cancelClickedInSelectYourShippingDestinationPopupSfParams
* @property {string} appName - app_name
* @property {GUID} cartId - null
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {GUID} checkoutId - checkout_id
* @property {GUID} ecomId - ecom_id
**/
/**
 * Name: Cart -> cancel clicked in select your shipping destination popup SF. Evid: 126.
 * Event description: in the cart page, when a user want to change is shipping address, to re calculate shipping cost estimation- cancel or x clicked.

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid.
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * ecomId - Type: guid. Desc: ecom_id
 * @param {cancelClickedInSelectYourShippingDestinationPopupSfParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cancelClickedInSelectYourShippingDestinationPopupSf = function (params) {
    return { evid: 126, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} cartViewMiniCartParams
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
* @property {number} itemsCount - Numbers of items in cart
* @property {boolean} is_member - true if the visitor signed in as a member, false otherwise
* @property {boolean} isMembersInstalled - true if members app installed on site, false otherwise
* @property {string} origin - cartIcon / addToCartButton
* @property {string} priceBreakdown - list of displayed price breakdowns - tax, shipping, etc. NULL if not relevant
* @property {GUID} siteMemberId - member id
* @property {string} viewMode - editor / site / preview
**/
/**
 * Name: Cart -> view mini cart. Evid: 50.
 * Event description: view mini cart pop-up.

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this cart separated by “ ,“:(stores app id, bookings app_id, ...)
 *
 * itemsCount - Type: numeric. Desc: Numbers of items in cart
 *
 * is_member - Type: bool. Desc: true if the visitor signed in as a member, false otherwise
 *
 * isMembersInstalled - Type: bool. Desc: true if members app installed on site, false otherwise
 *
 * origin - Type: string. Desc: cartIcon / addToCartButton
 *
 * priceBreakdown - Type: string. Desc: list of displayed price breakdowns - tax, shipping, etc. NULL if not relevant
 *
 * siteMemberId - Type: guid. Desc: member id
 *
 * viewMode - Type: string. Desc: editor / site / preview
 * @param {cartViewMiniCartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var cartViewMiniCart = function (params) {
    return { evid: 50, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} errorWhenApplyingACouponParams
* @property {string} appName - null
* @property {GUID} cartId - null
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {string} couponCode - null
* @property {string} errorCode - null
* @property {GUID} ecomId - ecom_id
* @property {boolean} isMember - null
* @property {boolean} isOwner - null
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {string} origin - null
* @property {GUID} owner_id - null
**/
/**
 * Name: Checkout -> Error when applying a coupon. Evid: 117.


 * appName - Type: string.
 *
 * cartId - Type: guid.
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * couponCode - Type: string.
 *
 * errorCode - Type: string.
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * isMember - Type: bool.
 *
 * isOwner - Type: bool.
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * origin - Type: string.
 *
 * owner_id - Type: guid.
 * @param {errorWhenApplyingACouponParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var errorWhenApplyingACoupon = function (params) {
    return { evid: 117, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} paymentDetailsCompletedParams
* @property {number} additionalFeesPrice - INT, multiplied by 100 000 - sum of all additional fees price in order
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} cartType - Digital/ Physical/ mixed (Digital &Physical)
* @property {string} catalogAppId - A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
* @property {GUID} checkoutId - checkout_id
* @property {number} optionscount - number of payment options
* @property {GUID} ecomId - ecom_id
* @property {number} selectedoptionindex - index of selected option
* @property {boolean} isOwner - true if visitor is the site owner
* @property {string} itemType - List of distinct checkout.lineItems.itemType
* @property {number} numberOfAdditionalFees - number of all additional fees in the order
* @property {string} paymentProvider - payment provider that was chosen
**/
/**
 * Name: Checkout -> Payment details completed. Evid: 177.
 * Event description: UoU clicked continue on payment details step in new checkout funnel. since june 2019 also sent from OA StoreFront (with origin).

 * additionalFeesPrice - Type: numeric. Desc: INT, multiplied by 100 000 - sum of all additional fees price in order
 *
 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * cartType - Type: string. Desc: Digital/ Physical/ mixed (Digital &Physical)
 *
 * catalogAppId - Type: string. Desc: A list of verticals which are in this order separated by “ ,“:(stores app id, bookings app_id, ...) .
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * optionscount - Type: numeric. Desc: number of payment options
 *
 * ecomId - Type: guid. Desc: ecom_id
 *
 * selectedoptionindex - Type: numeric. Desc: index of selected option
 *
 * isOwner - Type: bool. Desc: true if visitor is the site owner
 *
 * itemType - Type: string. Desc: List of distinct checkout.lineItems.itemType
 *
 * numberOfAdditionalFees - Type: numeric. Desc: number of all additional fees in the order
 *
 * paymentProvider - Type: string. Desc: payment provider that was chosen
 * @param {paymentDetailsCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var paymentDetailsCompleted = function (params) {
    return { evid: 177, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} bisClickOnTheSubmitButtonParams
* @property {GUID} appId - the app Id of the catalog
* @property {string} catalogAppId - catalog app id
* @property {GUID} catalogInstanceId - In case of stores (store_id)
* @property {string} catalogItemId - The guid of the requested item (product_guid / service_id..)
* @property {boolean} isEmailValid - true - email is valid and trigger to created a request, false - email is not valid and an error is shown
* @property {string} options - map of strings of the options chosen in the requested item
**/
/**
 * Name: BIS - Click on the submit button. Evid: 26.
 * Event description: When a user clicks on the submit button in 'notify me' modal
If the input email is valid, then it triggers to create a request on the server.
if the input email is not valid it will send an error.

 * appId - Type: guid. Desc: the app Id of the catalog
 *
 * catalogAppId - Type: string. Desc: catalog app id
 *
 * catalogInstanceId - Type: guid. Desc: In case of stores (store_id)
 *
 * catalogItemId - Type: string. Desc: The guid of the requested item (product_guid / service_id..)
 *
 * isEmailValid - Type: bool. Desc: true - email is valid and trigger to created a request, false - email is not valid and an error is shown
 *
 * options - Type: string. Desc: map of strings of the options chosen in the requested item
 * @param {bisClickOnTheSubmitButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bisClickOnTheSubmitButton = function (params) {
    return { evid: 26, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} buyerShippingCountryIsSetParams
* @property {string} appName - app_name
* @property {GUID} cartId - cart_id
* @property {string} catalogAppId - catalog_app_id
* @property {GUID} checkoutId - checkout_id
* @property {string} flowType - 'Cart'- if the region was selected in cart modal ; 'Checkout' - if the region was selected in checkout stage
* @property {boolean} is_member - true if the visitor signed in as a member, false otherwise
* @property {string} origin - 'OA StoreFront' (for OneApp)
* @property {GUID} owner_id - uuid of site owner
* @property {string} shippingCountry - The selected shipping country
**/
/**
 * Name: Click on dropdown to select shipping region. Evid: 661.
 * Event description: When a buyer (visitor/member) click on the shipping region dropdown   in checkout shippingAdress stage / in cart shipping calculator modal. (Created mainly as an exposure point for France regions AB test).

 * appName - Type: string. Desc: app_name
 *
 * cartId - Type: guid. Desc: cart_id
 *
 * catalogAppId - Type: string. Desc: catalog_app_id
 *
 * checkoutId - Type: guid. Desc: checkout_id
 *
 * flowType - Type: string. Desc: 'Cart'- if the region was selected in cart modal ; 'Checkout' - if the region was selected in checkout stage
 *
 * is_member - Type: bool. Desc: true if the visitor signed in as a member, false otherwise
 *
 * origin - Type: string. Desc: 'OA StoreFront' (for OneApp)
 *
 * owner_id - Type: guid. Desc: uuid of site owner
 *
 * shippingCountry - Type: string. Desc: The selected shipping country
 * @param {buyerShippingCountryIsSetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var buyerShippingCountryIsSet = function (params) {
    return { evid: 661, src: 130, endpoint: 'ec-site', params: params };
};
/**
* @typedef {Object} editorChangeElementSettingsSfeParams
* @property {string} appName - app_name
* @property {string} component_id - grid gallery, slider galeery, product page,CurrencyConverter, AvalaraTax
* @property {string} editorMode - mobile / desktop
* @property {string} element - product image, name&price&sku, product options&quantity, button, info sections, social media
* @property {string} new_value - ture/false,on/off, crop/fit...
* @property {string} origin - null
* @property {string} parameter - facebook,tweeter, image scaling, navigation position
* @property {string} value - 0/1 (0= 'Above and below cart', 1='only below cart')
**/
/**
 * Name: Editor-> change element settings SFE. Evid: 831.
 * Event description: change element settings in SF component settings.

 * appName - Type: string. Desc: app_name
 *
 * component_id - Type: string. Desc: grid gallery, slider galeery, product page,CurrencyConverter, AvalaraTax
 *
 * editorMode - Type: string. Desc: mobile / desktop
 *
 * element - Type: string. Desc: product image, name&price&sku, product options&quantity, button, info sections, social media
 *
 * new_value - Type: string. Desc: ture/false,on/off, crop/fit...
 *
 * origin - Type: string.
 *
 * parameter - Type: string. Desc: facebook,tweeter, image scaling, navigation position
 *
 * value - Type: string. Desc: 0/1 (0= 'Above and below cart', 1='only below cart')
 * @param {editorChangeElementSettingsSfeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editorChangeElementSettingsSfe = function (params) {
    return { evid: 831, src: 130, endpoint: 'ec-site', params: params };
};
//# sourceMappingURL=index.js.map